<template>
  <div class="page_basicData">
    <!-- 顶部导航 -->
    <!-- <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div> -->
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>基础数据</el-breadcrumb-item>
          <el-breadcrumb-item>社保夯实率</el-breadcrumb-item>
          <el-breadcrumb-item>{{ outerTab == 'dashboard' ? '驾驶舱' : outerTab == 'byCompany' ? '按公司主体' : outerTab ==
            'byProject'
            ? '按项目' : outerTab == 'byServiceDepart' ? '按服务部门' : outerTab == 'byPerson' ? '按人员' : '基础数据'
          }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 外层 tab -->
      <el-tabs v-model="outerTab" type="border-card" @tab-click="outerTabClick">
        <el-tab-pane label="驾驶舱" name="dashboard" v-if="checkPermission(['tab_dashboard'],permissionLists)">
          <!-- ================= 驾驶舱 ================= -->
          <div class="page_dashboard" v-if="outerTab === 'dashboard'">
            <div class="topOperation">
              <div class="top-left">
                <el-form :inline="true" :model="dashboardQuery" class="re_down_form" label-width="90px">
                  <el-form-item label="年度" size="small">
                    <el-select v-model="dashboardQuery.year" size="small" style="width:110px">
                      <el-option v-for="y in yearOptions" :key="y" :label="y + '年'" :value="String(y)"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="月份" size="small">
                    <el-select v-model="dashboardQuery.month" size="small" clearable placeholder="全部" style="width:90px">
                      <el-option v-for="m in 12" :key="m" :label="m + '月'" :value="String(m).padStart(2, '0')"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="省市" size="small">
                    <el-input v-model="dashboardQuery.province" placeholder="如 安徽 或 黄山市 或 安徽,黄山市" size="small" style="width:220px"></el-input>
                  </el-form-item>
                  <el-form-item label="公司主体" size="small">
                    <!-- 下拉数据由 getLegalList()（GetUserLegalList）填充 dashboardCompanyList；仅作用于汇总卡/排名看板的主体过滤；
                         注意：与「按主体」「按服务部门」趋势内的主体选择均解耦，互不联动 -->
                    <el-select v-model="dashboardQuery.companyName" multiple filterable collapse-tags max-collapse-tags="2" clearable placeholder="请选择主体（可多选）" size="small" style="width:260px" @change="loadDashboardData">
                      <el-option v-for="(item, index) in dashboardCompanyList" :key="index" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>
                  <!-- 下拉数据由 getProjectOptions() 调用 xz.getProjectLists 填充 dashboardProjectList；仅作用于汇总卡/排名看板的项目过滤；
                         注意：与「按项目」趋势内的独立项目选择(dashboardTrendProjects)解耦，互不联动 -->
                  <!-- <el-form-item label="项目" size="small">
                    <el-select v-model="dashboardQuery.projectName" multiple filterable collapse-tags clearable placeholder="请选择项目（可多选）" size="small" style="width:280px">
                      <el-option v-for="(item,index) in dashboardProjectList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
                    </el-select>
                  </el-form-item> -->
                  <el-form-item label="服务部门" size="small" style="margin-bottom: 0;">
                    <el-select v-model="dashboardQuery.serviceDepart" multiple filterable collapse-tags clearable placeholder="请选择服务部门（可多选）" size="small" style="width:280px" @change="onServiceDepartChange">
                      <el-option v-for="(item, index) in serviceDepartOptions" :key="index" :label="item" :value="item"></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </div>
              <div class="top-right">
                <el-button v-preventReClick type="primary" size="small" @click="loadDashboardData">查询</el-button>
                <el-button size="small" plain @click="dashboardReset">重置筛选</el-button>
              </div>
            </div>

            <!-- 9 个汇总卡片：主体(3) + 服务部门(3) + 项目(3) -->
            <div class="dash-cards">
              <div class="dash-card">
                <div class="title">主体总数</div>
                <div class="num">{{ dashboardSummary.companyTotal }}</div>
                <div class="unit">个</div>
              </div>
              <div class="dash-card">
                <div class="title">已达标准主体</div>
                <div class="num" style="color:#52c41a">{{ dashboardSummary.qualifiedCompany }}</div>
                <div class="unit">占比 {{ dashboardSummary.companyQualifiedRate }}</div>
              </div>
              <div class="dash-card">
                <div class="title">未达标主体</div>
                <div class="num" style="color:#ff4d4f">{{ dashboardSummary.unQualifiedCompany }}</div>
                <div class="unit">占比 {{ dashboardSummary.companyUnQualifiedRate }}</div>
              </div>
              <div class="dash-card">
                <div class="title">服务部门数</div>
                <div class="num">{{ dashboardSummary.serviceDeptTotal }}</div>
                <div class="unit">个</div>
              </div>
              <div class="dash-card">
                <div class="title">已达标准服务部门</div>
                <div class="num" style="color:#52c41a">{{ dashboardSummary.qualifiedServiceDept }}</div>
                <div class="unit">占比 {{ dashboardSummary.serviceDeptQualifiedRate }}</div>
              </div>
              <div class="dash-card">
                <div class="title">未达标服务部门</div>
                <div class="num" style="color:#ff4d4f">{{ dashboardSummary.unQualifiedServiceDept }}</div>
                <div class="unit">占比 {{ dashboardSummary.serviceDeptUnQualifiedRate }}</div>
              </div>
              <div class="dash-card">
                <div class="title">项目总数</div>
                <div class="num">{{ dashboardSummary.projectTotal }}</div>
                <div class="unit">个</div>
              </div>
              <div class="dash-card">
                <div class="title">已达标准项目</div>
                <div class="num" style="color:#52c41a">{{ dashboardSummary.qualifiedProject }}</div>
                <div class="unit">占比 {{ dashboardSummary.projectQualifiedRate }}</div>
              </div>
              <div class="dash-card">
                <div class="title">未达标项目</div>
                <div class="num" style="color:#ff4d4f">{{ dashboardSummary.unQualifiedProject }}</div>
                <div class="unit">占比 {{ dashboardSummary.projectUnQualifiedRate }}</div>
              </div>
            </div>

            <!-- 夯实率趋势 -->
            <div class="dash-block">
              <!-- 标题行：标题居左，统计区间（近12个月）居右 -->
              <div class="dash-block-header dash-trend-header">
                <span class="title">夯实率趋势</span>
                <el-select v-model="dashboardTrendRange" size="small" class="dash-trend-range" style="width:120px" @change="loadDashboardData">
                  <el-option label="近12个月" value="12"></el-option>
                  <el-option label="近6个月" value="6"></el-option>
                  <el-option label="近24个月" value="24"></el-option>
                  <el-option label="近3个月" value="3"></el-option>
                </el-select>
              </div>
              <!-- tab 单独一行（标题/区间之下），再往下是对应 tab 的下拉筛选行 -->
              <el-tabs v-model="dashboardTrendTab" class="dash-trend-tabs" @tab-click="dashboardTrendTabClick">
                <el-tab-pane label="按主体" name="company"></el-tab-pane>
                <el-tab-pane label="按服务部门" name="serviceDept"></el-tab-pane>
                <el-tab-pane label="按项目" name="project"></el-tab-pane>
              </el-tabs>
              <!-- 按服务部门 tab 的额外筛选：服务部门(可多选) + 公司主体(可多选)；
                   公司主体绑定独立的 dashboardTrendDeptCompanies，与顶部"公司主体"下拉(dashboardQuery.companyName)解耦，互不联动 -->
              <div v-if="dashboardTrendTab === 'serviceDept'" class="dash-trend-filter" style="padding: 0 12px 8px; display: flex; align-items: center; gap: 12px; flex-wrap: wrap;">
                <el-form :inline="true" size="small" style="margin: 0;">
                  <el-form-item label="服务部门" size="small" style="margin-bottom: 0;">
                    <el-select v-model="dashboardQuery.serviceDepart" multiple filterable collapse-tags clearable placeholder="请选择服务部门（可多选）" size="small" style="width:280px" @change="onServiceDepartChange">
                      <el-option v-for="(item, index) in dashboardServiceDeptList" :key="index" :label="item" :value="item"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="公司主体" size="small" style="margin-bottom: 0;">
                    <!-- 主体下拉可选范围与所选服务部门联动（onServiceDepartChange → GetCompanyListByServiceDepart 按部门过滤；未选部门时 = 数据权限内全部主体），
                         但选中值存于独立状态 dashboardTrendDeptCompanies，不回写顶部"公司主体"下拉 -->
                    <el-select v-model="dashboardTrendDeptCompanies" multiple filterable collapse-tags max-collapse-tags="2" clearable placeholder="请选择主体（可多选）" size="small" style="width:260px" @change="onTrendDeptCompanyChange">
                      <el-option v-for="(item, index) in dashboardDeptCompanyList" :key="index" :label="item" :value="item"></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </div>
              <!-- 按主体 tab 的额外筛选：选择主体(可多选) → 绑定独立的 dashboardTrendCompanies，与顶部"公司主体"下拉(dashboardQuery.companyName)解耦，互不联动 -->
              <div v-if="dashboardTrendTab === 'company'" class="dash-trend-filter" style="padding: 0 12px 8px; display: flex; align-items: center; gap: 12px; flex-wrap: wrap;">
                <el-form :inline="true" size="small" style="margin: 0;">
                  <el-form-item label="选择主体" size="small" style="margin-bottom: 0;">
                    <el-select v-model="dashboardTrendCompanies" multiple filterable collapse-tags max-collapse-tags="2" clearable placeholder="请选择主体（可多选）" size="small" style="width:320px" @change="onTrendCompanyChange">
                      <el-option v-for="(item, index) in dashboardCompanyList" :key="index" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>
                  <span style="color:red;font-size:12px;line-height: 28px;">提示：选多个主体即绘制多条曲线</span>
                </el-form>
              </div>
              <!-- 按项目 tab 的额外筛选：选择项目(可多选) → 绑定独立的 dashboardTrendProjects，与顶部"项目"下拉(dashboardQuery.projectName)解耦，互不联动 -->
              <div v-if="dashboardTrendTab === 'project'" class="dash-trend-filter" style="padding: 0 12px 8px; display: flex; align-items: center; gap: 12px; flex-wrap: wrap;">
                <el-form :inline="true" size="small" style="margin: 0;">
                  <el-form-item label="选择项目" size="small" style="margin-bottom: 0;">
                    <!-- 选项与顶部"项目"下拉共用 getProjectOptions 填充的 dashboardProjectList，但选中值存于独立状态 dashboardTrendProjects，不回写顶部下拉 -->
                    <el-select v-model="dashboardTrendProjects" multiple filterable collapse-tags max-collapse-tags="2" clearable placeholder="请选择项目（可多选）" size="small" style="width:320px" @change="onTrendProjectChange">
                      <el-option v-for="(item, index) in dashboardProjectList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
                    </el-select>
                  </el-form-item>
                  <span style="color:#999;font-size:12px;">选多个项目即绘制多条曲线</span>
                </el-form>
              </div>
              <!-- 按主体 tab：区间内存在未达标月份的主体（达标要求 = 各主体自身年度档案 ConsolidationRate，
                   未选主体时按数据权限内全部主体统计；总体曲线不参与判定） -->
              <!-- <div v-if="dashboardTrendTab==='company' && dashboardUnQualifiedCompanies.length"
                style="padding: 0 12px 8px; display: flex; align-items: center; gap: 6px; flex-wrap: wrap; font-size: 12px;">
                <span style="color:#ff4d4f;font-weight:600;">未达标主体：</span>
                <el-tag v-for="(c,index) in dashboardUnQualifiedCompanies" :key="index" type="danger" size="mini" style="margin: 2px 0;">
                  {{ c.companyName }}（要求 {{ c.requireRate }}%，最近 {{ c.lastRate }}%，{{ c.unQualifiedMonthCount }} 个月未达标）
                </el-tag>
              </div> -->
              <div ref="dashChart" style="width:100%;height:420px;"></div>
            </div>

            <!-- 排名看板 -->
            <div class="dash-block">
              <div class="dash-block-header">
                <span class="title">排名看板</span>
                <span class="stat-period">{{ rankPeriodText() }}</span>
              </div>
              <el-tabs v-model="dashboardRankActive" class="dash-rank-tabs" @tab-click="dashboardRankTabClick">
                <el-tab-pane label="主体排名" name="company">
                  <el-tabs v-model="dashboardRankSub" class="dash-inline-tabs" @tab-click="dashboardRankSubTabClick">
                    <el-tab-pane label="未达标差异率 Top10" name="unQualified">
                      <div class="rank-tip">排序说明：未达标按缺口从大到小；已达标按超额从大到小</div>
                    </el-tab-pane>
                    <el-tab-pane label="未达标差异金额 Top10" name="diff">
                      <div class="rank-tip">排序说明：未达标按缺口金额从大到小</div>
                    </el-tab-pane>
                    <el-tab-pane label="已达标差异率 Top10" name="qualified">
                      <div class="rank-tip">排序说明：已达标按超额从大到小</div>
                    </el-tab-pane>
                    <el-tab-pane label="已达标差异金额 Top10" name="qualifiedRate">
                      <div class="rank-tip">排序说明：已达标按超额金额从大到小</div>
                    </el-tab-pane>
                  </el-tabs>
                </el-tab-pane>
                <el-tab-pane label="服务部门排名" name="serviceDept">
                  <el-tabs v-model="dashboardRankSub" class="dash-inline-tabs" @tab-click="dashboardRankSubTabClick">
                    <el-tab-pane label="未达标差异率 Top10" name="unQualified">
                      <div class="rank-tip">排序说明：未达标按缺口从大到小；已达标按超额从大到小</div>
                    </el-tab-pane>
                    <el-tab-pane label="未达标差异金额 Top10" name="diff">
                      <div class="rank-tip">排序说明：未达标按缺口金额从大到小</div>
                    </el-tab-pane>
                    <el-tab-pane label="已达标差异率 Top10" name="qualified">
                      <div class="rank-tip">排序说明：已达标按超额从大到小</div>
                    </el-tab-pane>
                    <el-tab-pane label="已达标差异金额 Top10" name="qualifiedRate">
                      <div class="rank-tip">排序说明：已达标按超额金额从大到小</div>
                    </el-tab-pane>
                  </el-tabs>
                </el-tab-pane>
                <el-tab-pane label="项目排名" name="project">
                  <el-tabs v-model="dashboardRankSub" class="dash-inline-tabs" @tab-click="dashboardRankSubTabClick">
                    <el-tab-pane label="未达标差异率 Top10" name="unQualified">
                      <div class="rank-tip">排序说明：未达标按缺口从大到小；已达标按超额从大到小</div>
                    </el-tab-pane>
                    <el-tab-pane label="未达标差异金额 Top10" name="diff">
                      <div class="rank-tip">排序说明：未达标按缺口金额从大到小</div>
                    </el-tab-pane>
                    <el-tab-pane label="已达标差异率 Top10" name="qualified">
                      <div class="rank-tip">排序说明：已达标按超额从大到小</div>
                    </el-tab-pane>
                    <el-tab-pane label="已达标差异金额 Top10" name="qualifiedRate">
                      <div class="rank-tip">排序说明：已达标按超额金额从大到小</div>
                    </el-tab-pane>
                  </el-tabs>
                </el-tab-pane>
              </el-tabs>
              <div v-if="dashboardRankLoading" style="text-align:center;padding:40px 0;color:#999;">
                <i class="el-icon-loading"></i> 数据加载中...
              </div>
              <el-table v-else :data="dashboardRankTable" border class="doc_table" max-height="380" style="width:100%;background:#fff">
                <el-table-column label="排名" type="index" width="60" align="center" fixed="left"></el-table-column>
                <el-table-column :label="dashboardRankActive === 'company' ? '主体名称' : (dashboardRankActive === 'serviceDept' ? '服务部门名称' : '项目名称')" min-width="160" show-overflow-tooltip prop="name" fixed="left"></el-table-column>
                <el-table-column label="参保人数" width="90" align="right">
                  <template slot-scope="s">{{ s.row.socialSecurityCount === null || s.row.socialSecurityCount ===
                    undefined || s.row.socialSecurityCount === '' ? '-' : s.row.socialSecurityCount }}</template>
                </el-table-column>
                <el-table-column label="平均薪资基数" width="120" align="right">
                  <template slot-scope="s">{{ formatMoney(s.row.salaryAvg) }}</template>
                </el-table-column>
                <el-table-column label="平均社保基数" width="120" align="right">
                  <template slot-scope="s">{{ formatMoney(s.row.socialSecurityAvg) }}</template>
                </el-table-column>
                <el-table-column label="社保基数合计" width="130" align="right">
                  <template slot-scope="s">{{ formatMoney(s.row.socialTotal) }}</template>
                </el-table-column>
                <el-table-column label="薪资基数合计" width="130" align="right">
                  <template slot-scope="s">{{ formatMoney(s.row.salaryTotal) }}</template>
                </el-table-column>
                <el-table-column label="实际夯实率" width="110" align="center">
                  <template slot-scope="s">{{ s.row.rate === null || s.row.rate === undefined || s.row.rate === '' ? '-'
                    :
                    Number(s.row.rate).toFixed(2) + '%' }}</template>
                </el-table-column>
                <!-- 达标要求：仅主体排名展示（项目/服务部门内各主体达标要求不一，不显示） -->
                <el-table-column v-if="dashboardRankActive === 'company'" label="达标要求" width="100" align="center">
                  <template slot-scope="s">{{ s.row.require === null || s.row.require === undefined || s.row.require ===
                    '' ? '-'
                    : Number(s.row.require) + '%' }}</template>
                </el-table-column>
                <!-- 主体排名列序：差异率 → 差异金额 -->
                <template v-if="dashboardRankActive === 'company'">
                  <el-table-column label="差异率" width="100" align="center">
                    <template slot-scope="s">
                      <span v-if="s.row.diffRate === null || s.row.diffRate === undefined || s.row.diffRate === ''" style="color:#bbb">-</span>
                      <span v-else :style="{ color: Number(s.row.diffRate) >= 0 ? '#52c41a' : '#ff4d4f', fontWeight: 600 }">{{
                          Number(s.row.diffRate) >= 0 ? '+' : '' }}{{ Number(s.row.diffRate).toFixed(2) }}%</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="差异金额" width="140" align="right">
                    <template slot-scope="s">
                      <span v-if="s.row.diffAmount === null || s.row.diffAmount === undefined || s.row.diffAmount === ''" style="color:#bbb">-</span>
                      <span v-else :style="{ color: Number(s.row.diffAmount) >= 0 ? '#52c41a' : '#ff4d4f', fontWeight: 600 }">{{
                          formatMoney(s.row.diffAmount) }}</span>
                    </template>
                  </el-table-column>
                </template>
                <!-- 项目/服务部门排名列序：差异金额(第5列) → 差异率(第6列) -->
                <template v-else>
                  <el-table-column label="差异金额" width="140" align="right">
                    <template slot-scope="s">
                      <span v-if="s.row.diffAmount === null || s.row.diffAmount === undefined || s.row.diffAmount === ''" style="color:#bbb">-</span>
                      <span v-else :style="{ color: Number(s.row.diffAmount) >= 0 ? '#52c41a' : '#ff4d4f', fontWeight: 600 }">{{
                          formatMoney(s.row.diffAmount) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="差异率" width="100" align="center">
                    <template slot-scope="s">
                      <span v-if="s.row.diffRate === null || s.row.diffRate === undefined || s.row.diffRate === ''" style="color:#bbb">-</span>
                      <span v-else :style="{ color: Number(s.row.diffRate) >= 0 ? '#52c41a' : '#ff4d4f', fontWeight: 600 }">{{
                          Number(s.row.diffRate) >= 0 ? '+' : '' }}{{ Number(s.row.diffRate).toFixed(2) }}%</span>
                    </template>
                  </el-table-column>
                </template>
                <el-table-column label="状态" width="90" align="center">
                  <template slot-scope="s">
                    <el-tag :type="s.row.qualified === '达标' ? 'success' : 'danger'" size="mini">{{ s.row.qualified ||
                      (s.row.diffRate < 0 ? '未达标' : '达标') }}</el-tag>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="按公司主体" name="byCompany" v-if="checkPermission(['tab_byCompany'],permissionLists)">
          <!-- ================= 按公司主体统计 ================= -->
          <div class="page_byCompany">
            <div class="topOperation">
              <div class="top-left">
                <el-form :inline="true" :model="byCompanyQuery" class="re_down_form" label-width="90px">
                  <el-form-item label="公司主体" size="small">
                    <el-select v-model="byCompanyQuery.companyName" filterable clearable placeholder="请选择" size="small" style="width:200px">
                      <el-option v-for="(item, index) in legList" :key="index" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="税款所属期" size="small">
                    <el-date-picker v-model="byCompanyQuery.billingMonth" type="month" placeholder="选择税款所属期" size="small" value-format="yyyyMM" style="width:130px">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="是否达标" size="small">
                    <el-select v-model="byCompanyQuery.annualQualified" filterable clearable placeholder="请选择" size="small" style="width:130px" @change="auqChange">
                      <el-option label="达标" value="达标"></el-option>
                      <el-option label="未达标" value="未达标"></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </div>
              <div class="top-right">
                <el-button v-preventReClick type="primary" size="small" @click="byCompanySearch">搜索</el-button>
                <el-button size="small" plain @click="byCompanyReset">重置</el-button>
                <el-button size="small" plain type="danger" @click="openCompanyLockDialog(1)">锁定</el-button>
                <el-button size="small" plain type="success" @click="openCompanyLockDialog(0)">解锁</el-button>
                <el-button type="warning" size="small" plain @click="byCompanyExport">导出</el-button>
              </div>
            </div>

            <!-- 顶部汇总卡片：达标/未达标主体数 + 社保人数/报税人数（口径与列表列一致） -->
            <div class="byCompany-summary" v-if="byCompanyTableData.length > 0">
              <div class="sum-row">
                <span>年度：{{ byCompanySummary.year }}，</span>
                公司主体数：<span class="num num-dark">{{ byCompanySummary.companyCount }}</span> 个，
                达标主体：<span class="num num-green">{{ byCompanySummary.qualifiedCompanyCount }}</span> 个 |
                未达标主体：<span class="num num-red">{{ byCompanySummary.unQualifiedCompanyCount }}</span> 个
              </div>
              <div class="sum-row">
                社保人数：<span class="num num-purple">{{ byCompanySummary.salaryBaseTotalCount }}</span> 人 |
                报税人数：<span class="num num-purple">{{ byCompanySummary.incomeTaxTotalCount }}</span> 人 |
                基数匹配率：<span class="num num-purple">{{ formatPercent(byCompanySummary.matchRate) }}</span>|
                <span>更新时间：{{ byCompanySummary.updateTime }}</span>
              </div>
            </div>

            <div class="main-con">
              <el-table :data="byCompanyTableData" border class="doc_table" max-height="450px" v-loading="byCompanyLoading" style="width:100%; background:#fff">
                <el-table-column label="序号" width="60" align="center" type="index" fixed="left"></el-table-column>
                <el-table-column label="公司主体" prop="companyName" min-width="180" show-overflow-tooltip fixed="left"></el-table-column>
                <el-table-column label="税款所属期" prop="taxPeriod" width="110" align="center"></el-table-column>
                <el-table-column label="社保人数" prop="salaryBaseCount" width="100" align="center"></el-table-column>
                <el-table-column label="报税人数" prop="salaryOnlyCount" width="100" align="center"></el-table-column>
                <el-table-column label="有社保且报税人数" prop="bothCount" width="130" align="center"></el-table-column>
                <el-table-column label="社保基数平均值" width="130" align="right">
                  <template slot-scope="scope">{{ formatMoney(scope.row.SocialSecurityAvg) }}</template>
                </el-table-column>
                <el-table-column label="薪资基数平均值" width="130" align="right">
                  <template slot-scope="scope">{{ formatMoney(scope.row.salaryAvg) }}</template>
                </el-table-column>
                <el-table-column label="月度基数夯实率" width="120" align="center">
                  <template slot-scope="scope">{{ formatPercent(scope.row.monthlyRate) }}</template>
                </el-table-column>
                <el-table-column label="年度基数夯实率" width="120" align="center" :cell-style="rateCellStyle">
                  <template slot-scope="scope">{{ formatPercent(scope.row.annualRate) }}</template>
                </el-table-column>
                <el-table-column label="年度夯实率差异值" width="130" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.annualRateDiff === null || scope.row.annualRateDiff === undefined || scope.row.annualRateDiff === ''">-</span>
                    <span v-else :style="{ color: Number(scope.row.annualRateDiff) >= 0 ? '#52c41a' : '#ff4d4f', fontWeight: 600 }">
                      {{ (Number(scope.row.annualRateDiff) >= 0 ? '+' : '') + formatPercent(scope.row.annualRateDiff) }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="年度是否达标" width="110" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.annualQualified === '达标'" style="color:#52c41a; font-weight:600;">达标</span>
                    <span v-else-if="scope.row.annualQualified === '未达标'" style="color:#ff4d4f; font-weight:600;">未达标</span>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column label="月度人数夯实率" width="130" align="center">
                  <template slot-scope="scope">{{ formatPercent(scope.row.monthlyPersonRate) }}</template>
                </el-table-column>
                <el-table-column label="年度人数夯实率" width="130" align="center">
                  <template slot-scope="scope">-</template>
                </el-table-column>
                <el-table-column label="锁定状态" width="110" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.lockState === '锁定'" style="color:#ff4d4f; font-weight:600;">锁定</span>
                    <span v-else-if="scope.row.lockState === '解锁'" style="color:#52c41a; font-weight:600;">解锁</span>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="按服务部门" name="byServiceDepart" v-if="checkPermission(['tab_byServiceDepart'],permissionLists)">
          <!-- ================= 按服务部门统计 ================= -->
          <div class="page_byServiceDept">
            <div class="topOperation">
              <div class="top-left">
                <el-form :inline="true" :model="byServiceDepartQuery" class="re_down_form" label-width="90px">
                  <el-form-item label="服务部门" size="small">
                    <el-select v-model="byServiceDepartQuery.serviceDepart" filterable clearable placeholder="请选择" size="small" style="width:180px" @change="onByServiceDepartChange">
                      <el-option v-for="(item, index) in serviceDepartOptions" :key="index" :label="item" :value="item"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="公司主体" size="small">
                    <el-select v-model="byServiceDepartQuery.companyName" filterable clearable placeholder="请选择" size="small" style="width:180px">
                      <el-option v-for="(item, index) in byServiceDepartCompanyList" :key="index" :label="item" :value="item"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="税款所属期" size="small">
                    <el-date-picker v-model="byServiceDepartQuery.billingMonth" type="month" placeholder="选择税款所属期" size="small" value-format="yyyyMM" style="width:150px">
                    </el-date-picker>
                  </el-form-item>
                </el-form>
              </div>
              <div class="top-right">
                <el-button v-preventReClick type="primary" size="small" @click="byServiceDepartSearch">搜索</el-button>
                <el-button size="small" plain @click="byServiceDepartReset">重置</el-button>
                <el-button type="warning" size="small" plain @click="byServiceDepartExport">导出</el-button>
              </div>
            </div>

            <!-- 顶部汇总卡片 -->

            <!-- <div class="byServiceDept-summary" v-if="byServiceDepartTableData.length > 0">
              服务部门：<span class="num">{{ byServiceDepartSummary.serviceDeptCount }}</span> 个，基数匹配率：<span class="num">{{
                formatPercent(byServiceDepartSummary.matchRate) }}</span>
            </div> -->
            <div class="byCompany-summary" v-if="byServiceDepartTableData.length > 0">
              <div class="sum-row">
                <span>年度：{{ byServiceDepartSummary.year }}年 |</span>
                服务部门数：<span class="num num-dark">{{ byServiceDepartSummary.serviceDeptCount }}</span> 个 |
                达标：<span class="num num-green">{{ byServiceDepartSummary.qualifiedCount }}</span> 个 |
                未达标：<span class="num num-red">{{ byServiceDepartSummary.unQualifiedCount }}</span> 个 |
                社保人数：<span class="num num-purple">{{ byServiceDepartSummary.socialSecurityCount }}</span> 个 |
                报税人数：<span class="num num-purple">{{ byServiceDepartSummary.incomeTaxCount }}</span> 个
              </div>
            </div>

            <div class="main-con">
              <el-table :data="byServiceDepartTableData" border class="doc_table" max-height="450px" v-loading="byServiceDepartLoading" style="width:100%; background:#fff">
                <el-table-column label="序号" width="60" align="center" type="index" fixed="left"></el-table-column>
                <el-table-column label="服务部门" prop="serviceDepart" min-width="180" show-overflow-tooltip fixed="left"></el-table-column>
                <el-table-column label="公司主体" prop="companyName" min-width="180" show-overflow-tooltip></el-table-column>
                <el-table-column label="税款所属期" prop="taxPeriod" width="110" align="center"></el-table-column>
                <el-table-column label="社保人数" prop="socialSecurityCount" width="100" align="center"></el-table-column>
                <el-table-column label="报税人数" prop="salaryOnlyCount" width="100" align="center"></el-table-column>
                <el-table-column label="有社保且报税人数" prop="bothCount" width="130" align="center"></el-table-column>
                <el-table-column label="社保基数平均值" width="130" align="right">
                  <template slot-scope="scope">{{ formatMoney(scope.row.socialSecurityAvg) }}</template>
                </el-table-column>
                <el-table-column label="薪资基数平均值" width="130" align="right">
                  <template slot-scope="scope">{{ formatMoney(scope.row.salaryAvg) }}</template>
                </el-table-column>
                <el-table-column label="月度基数夯实率" width="120" align="center">
                  <template slot-scope="scope">{{ formatPercent(scope.row.monthlyRate) }}</template>
                </el-table-column>
                <el-table-column label="年度夯实率差异值" width="130" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.annualRateDiff === null || scope.row.annualRateDiff === undefined || scope.row.annualRateDiff === ''">-</span>
                    <span v-else :style="{ color: Number(scope.row.annualRateDiff) >= 0 ? '#52c41a' : '#ff4d4f', fontWeight: 600 }">
                      {{ (Number(scope.row.annualRateDiff) >= 0 ? '+' : '') + formatPercent(scope.row.annualRateDiff) }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="年度是否达标" width="110" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.annualQualified === '达标'" style="color:#52c41a; font-weight:600;">达标</span>
                    <span v-else-if="scope.row.annualQualified === '未达标'" style="color:#ff4d4f; font-weight:600;">未达标</span>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column label="月度人数夯实率" width="130" align="center">
                  <template slot-scope="scope">{{ formatPercent(scope.row.monthlyPersonRate) }}</template>
                </el-table-column>
                <el-table-column label="年度人数夯实率" width="130" align="center">
                  <template slot-scope="scope">-</template>
                </el-table-column>
                <el-table-column label="操作" width="100" align="center" fixed="right">
                  <template slot-scope="scope">
                    <div class="injuryTabBtn">
                      <el-button type="text" size="small" @click="byServiceDepartViewDetail(scope.row)">人员明细</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="按项目" name="byProject" v-if="checkPermission(['tab_byProject'],permissionLists)">
          <!-- ================= 按项目统计 ================= -->
          <div class="page_byProject">
            <div class="topOperation">
              <div class="top-left">
                <el-form :inline="true" :model="byProjectQuery" class="re_down_form" label-width="90px">
                  <el-form-item label="项目名称" size="small">
                    <el-select v-model="byProjectQuery.projectName" filterable clearable placeholder="请选择" size="small" style="width:160px">
                      <el-option v-for="(item, index) in projectNameOptions" :key="index" :label="item" :value="item"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="公司主体" size="small">
                    <el-select v-model="byProjectQuery.companyName" filterable clearable placeholder="请选择" size="small" style="width:180px">
                      <el-option v-for="(item, index) in legList" :key="index" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="业绩归属人" size="small">
                    <el-tooltip content="该筛选需接入项目缓存表后启用" placement="top">
                      <el-select v-model="byProjectQuery.performanceOwner" disabled placeholder="待接入" size="small" style="width:140px">
                      </el-select>
                    </el-tooltip>
                  </el-form-item>
                  <el-form-item label="客服" size="small">
                    <el-tooltip content="该筛选需接入项目缓存表后启用" placement="top">
                      <el-select v-model="byProjectQuery.servicePerson" disabled placeholder="待接入" size="small" style="width:140px">
                      </el-select>
                    </el-tooltip>
                  </el-form-item>
                  <el-form-item label="税款所属期" size="small">
                    <el-date-picker v-model="byProjectQuery.billingMonth" type="month" placeholder="选择税款所属期" size="small" value-format="yyyyMM" style="width:150px">
                    </el-date-picker>
                  </el-form-item>
                </el-form>
              </div>
              <div class="top-right">
                <el-button v-preventReClick type="primary" size="small" @click="byProjectSearch">搜索</el-button>
                <el-button size="small" plain @click="byProjectReset">重置</el-button>
                <el-button type="warning" size="small" plain @click="byProjectExport">导出</el-button>
              </div>
            </div>

            <!-- 顶部汇总卡片 -->
            <!-- <div class="byProject-summary" v-if="byProjectTableData.length > 0">
              项目：<span class="num">{{ byProjectSummary.projectCount }}</span> 个，基数匹配率：<span class="num">{{
                formatPercent(byProjectSummary.matchRate) }}</span>
            </div> -->
            <div class="byCompany-summary" v-if="byProjectTableData.length > 0">
              <div class="sum-row">
                <span>年度：{{ byProjectSummary.year }}年 |</span>
                项目数：<span class="num num-dark">{{ byProjectSummary.projectCount }}</span> 个 |
                达标：<span class="num num-green">{{ byProjectSummary.qualifiedCount }}</span> 个 |
                未达标：<span class="num num-red">{{ byProjectSummary.unQualifiedCount }}</span> 个 |
                社保人数：<span class="num num-purple">{{ byProjectSummary.socialSecurityCount }}</span> 个 |
                报税人数：<span class="num num-purple">{{ byProjectSummary.incomeTaxCount }}</span> 个
              </div>
            </div>

            <div class="main-con">
              <el-table :data="byProjectTableData" border class="doc_table" max-height="450px" v-loading="byProjectLoading" style="width:100%; background:#fff">
                <el-table-column label="序号" width="60" align="center" type="index" fixed="left"></el-table-column>
                <el-table-column label="项目" prop="projectName" min-width="180" show-overflow-tooltip fixed="left"></el-table-column>
                <el-table-column label="公司主体" prop="companyName" min-width="180" show-overflow-tooltip></el-table-column>
                <el-table-column label="税款所属期" prop="taxPeriod" width="110" align="center"></el-table-column>
                <el-table-column label="社保人数" prop="socialSecurityCount" width="100" align="center"></el-table-column>
                <el-table-column label="报税人数" prop="salaryOnlyCount" width="100" align="center"></el-table-column>
                <el-table-column label="有社保且报税人数" prop="bothCount" width="130" align="center"></el-table-column>
                <el-table-column label="社保基数平均值" width="130" align="right">
                  <template slot-scope="scope">{{ formatMoney(scope.row.socialSecurityAvg) }}</template>
                </el-table-column>
                <el-table-column label="薪资基数平均值" width="130" align="right">
                  <template slot-scope="scope">{{ formatMoney(scope.row.salaryAvg) }}</template>
                </el-table-column>
                <el-table-column label="月度基数夯实率" width="120" align="center">
                  <template slot-scope="scope">{{ formatPercent(scope.row.monthlyRate) }}</template>
                </el-table-column>
                <el-table-column label="年度基数夯实率" width="120" align="center" :cell-style="rateCellStyle">
                  <template slot-scope="scope">{{ formatPercent(scope.row.annualRate) }}</template>
                </el-table-column>
                <el-table-column label="年度夯实率差异值" width="130" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.annualRateDiff === null || scope.row.annualRateDiff === undefined || scope.row.annualRateDiff === ''">-</span>
                    <span v-else :style="{ color: Number(scope.row.annualRateDiff) >= 0 ? '#52c41a' : '#ff4d4f', fontWeight: 600 }">
                      {{ (Number(scope.row.annualRateDiff) >= 0 ? '+' : '') + formatPercent(scope.row.annualRateDiff) }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="年度是否达标" width="110" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.annualQualified === '达标'" style="color:#52c41a; font-weight:600;">达标</span>
                    <span v-else-if="scope.row.annualQualified === '未达标'" style="color:#ff4d4f; font-weight:600;">未达标</span>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column label="月度人数夯实率" width="130" align="center">
                  <template slot-scope="scope">{{ formatPercent(scope.row.monthlyPersonRate) }}</template>
                </el-table-column>
                <el-table-column label="年度人数夯实率" width="130" align="center">
                  <template slot-scope="scope">-</template>
                </el-table-column>
                <el-table-column label="操作" width="100" align="center" fixed="right">
                  <template slot-scope="scope">
                    <div class="injuryTabBtn">
                      <el-button type="text" size="small" @click="byProjectViewDetail(scope.row)">人员明细</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="按人员" name="byPerson" v-if="checkPermission(['tab_byPerson'],permissionLists)">
          <!-- ================= 基础数据列表 ================= -->
          <div class="page_importDetail">
            <div class="topOperation">
              <div class="top-left">
                <el-form :inline="true" :model="importDetailQuery" class="re_down_form" label-width="90px">
                  <el-form-item label="公司主体" size="small">
                    <el-select v-model="importDetailQuery.companyName" filterable clearable placeholder="请选择" size="small" style="width:180px">
                      <el-option v-for="(item, index) in legList" :key="index" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="项目名称" size="small">
                    <el-select v-model="importDetailQuery.projectName" filterable clearable placeholder="请选择" size="small" style="width:160px">
                      <el-option v-for="(item, index) in projectNameOptions" :key="index" :label="item" :value="item"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="姓名" size="small">
                    <el-input v-model="importDetailQuery.name" clearable placeholder="请输入姓名" size="small" style="width:140px"></el-input>
                  </el-form-item>
                  <el-form-item label="证件号码" size="small">
                    <el-input v-model="importDetailQuery.cardId" clearable placeholder="请输入证件号码" size="small" style="width:170px"></el-input>
                  </el-form-item>
                  <el-form-item label="税款所属期" size="small">
                    <el-date-picker v-model="importDetailQuery.billingMonth" type="month" placeholder="选择税款所属期" size="small" value-format="yyyyMM" style="width:150px">
                    </el-date-picker>
                  </el-form-item>
                </el-form>
              </div>
              <div class="top-right">
                <el-button v-preventReClick type="primary" size="small" @click="importDetailSearch">搜索</el-button>
                <el-button size="small" plain @click="importDetailReset">重置</el-button>
                <el-button type="warning" size="small" plain @click="importDetailExport">导出</el-button>
                <el-button type="success" size="small" plain @click="openForecastSupple">生成预测补缴数据</el-button>
              </div>
            </div>

            <div class="byCompany-summary" v-if="importDetailTableData.length > 0">
              <div class="sum-row">
                <span>年度：{{ byPersonSummary.year }}，</span>

                社保人数：<span class="num num-purple">{{ byCompanySummary.salaryBaseTotalCount }}</span> 人 |
                报税人数：<span class="num num-purple">{{ byCompanySummary.incomeTaxTotalCount }}</span> 人 |
                达标人数：<span class="num num-green"></span>- 人|
                未达标人数：<span class="num num-red"></span>- 人
                <!-- 基数匹配率：<span class="num num-purple">{{ formatPercent(byServiceDepartSummary.matchRate) }}</span> -->
              </div>
            </div>
            <div class="main-con">
              <el-table :data="importDetailTableData" border class="doc_table" max-height="450px" v-loading="importDetailLoading" style="width:100%; background:#fff">
                <el-table-column label="税款所属期" prop="taxPeriod" width="100" align="center" fixed="left"></el-table-column>
                <el-table-column label="项目名称" prop="projectName" width="150" align="center" fixed="left"></el-table-column>
                <el-table-column label="姓名" prop="name" min-width="110" align="center" fixed="left"></el-table-column>
                <el-table-column label="证件号码" prop="cardId" min-width="160" align="center"></el-table-column>
                <el-table-column label="公司主体" prop="companyName" min-width="240" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column label="税前薪资" prop="originalSalary" min-width="110" align="center">
                  <template slot-scope="scope">{{ scope.row.originalSalary != null ? scope.row.originalSalary :
                    '' }}</template>
                </el-table-column>
                <el-table-column label="社保基数" prop="socialSecurityBase" min-width="110" align="center">
                  <template slot-scope="scope">{{ scope.row.socialSecurityBase != null ? scope.row.socialSecurityBase :
                    '' }}</template>
                </el-table-column>
                <el-table-column label="薪资基数" prop="salaryBase" min-width="110" align="center">
                  <template slot-scope="scope">{{ scope.row.salaryBase != null ? scope.row.salaryBase : '' }}</template>
                </el-table-column>
                <el-table-column label="月度基数夯实率" prop="monthlyRate" min-width="120" align="center">
                  <template slot-scope="scope">{{ formatPercent(scope.row.monthlyRate) }}</template>
                </el-table-column>
                <el-table-column label="年度基数夯实率" prop="annualBaseConsolidationRate" min-width="130" align="center" :cell-style="rateCellStyle">
                  <template slot-scope="scope">{{ formatPercent(scope.row.annualBaseConsolidationRate) }}</template>
                </el-table-column>
                <el-table-column label="年度夯实率差异值" min-width="130" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.annualRateDiff === null || scope.row.annualRateDiff === undefined || scope.row.annualRateDiff === ''">-</span>
                    <span v-else :style="{ color: Number(scope.row.annualRateDiff) >= 0 ? '#52c41a' : '#ff4d4f', fontWeight: 600 }">
                      {{ (Number(scope.row.annualRateDiff) >= 0 ? '+' : '') + formatPercent(scope.row.annualRateDiff) }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="年度是否达标" min-width="110" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.annualQualified === '达标'" style="color:#52c41a; font-weight:600;">达标</span>
                    <span v-else-if="scope.row.annualQualified === '未达标'" style="color:#ff4d4f; font-weight:600;">未达标</span>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column label="账单项目" prop="billingProject" min-width="120" align="center">
                  <template slot-scope="scope">{{ scope.row.billingProject || '-' }}</template>
                </el-table-column>
                <el-table-column label="发放项目" prop="payProjectName" min-width="200" align="center"></el-table-column>
              </el-table>

              <el-pagination v-if="importDetailPageTotal > 0" background layout="total, sizes, prev, pager, next, jumper" :total="importDetailPageTotal" :current-page.sync="importDetailQuery.PageModel.Page" :page-size.sync="importDetailQuery.PageModel.Rows" :page-sizes="[10, 20, 50, 100]" @size-change="getImportDetailList()" @current-change="getImportDetailList()" style="background:#fff; padding:15px; text-align:right"></el-pagination>
            </div>
          </div>
        </el-tab-pane>

        <!-- 基础数据 -->
        <el-tab-pane label="基础数据" name="basicData" v-if="checkPermission(['tab_basicData'],permissionLists)">
          <!-- 内层子 tab -->
          <el-tabs v-model="innerTab" @tab-click="innerTabClick">
            <el-tab-pane label="报税数据" name="taxData">
              <div class="page_socialSecurityList">
                <div class="topOperation">
                  <div class="top-left">
                    <el-form :inline="true" :model="taxListQuery" class="re_down_form" label-width="100px">
                      <el-form-item label="导入类型" size="small">
                        <el-select v-model="taxListQuery.importType" clearable placeholder="全部" size="small" style="width:160px">
                          <el-option label="首次导入" value="FirstImport"></el-option>
                          <el-option label="按月导入" value="MonthImport"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="税款所属期" size="small">
                        <el-date-picker v-model="taxListQuery.dataPeriod" type="month" value-format="yyyy-MM" size="small" style="width: 130px;"></el-date-picker>
                      </el-form-item>
                      <el-form-item label="导入人" size="small">
                        <el-input v-model="taxListQuery.importUserName" clearable placeholder="请输入姓名" size="small" style="width:130px"></el-input>
                      </el-form-item>
                    </el-form>
                  </div>
                  <div class="top-right">
                    <el-button v-preventReClick type="success" size="small" @click="taxSearchHandle">搜索</el-button>
                    <el-button size="small" plain @click="taxResetQuery">重置</el-button>
                  </div>
                </div>

                <div class="ftabBtn flex" style="background:#fff; padding: 10px 15px; border-top: 1px solid #ebeef5;">
                  <el-button type="success" size="small" @click="taxImportExcel" v-preventReClick style="margin-left:10px">导入报税数据</el-button>
                </div>

                <div class="main-con">
                  <el-table :data="taxTableData" border class="doc_table" max-height="450px" v-loading="taxLoading" style="width:100%; background:#fff">
                    <el-table-column label="批次号" prop="batchNo" min-width="150" align="center" fixed="left"></el-table-column>
                    <el-table-column label="导入类型" min-width="100" align="center">
                      <template slot-scope="scope">{{ scope.row.importType == 'FirstImport' ? '首次导入' : '按月导入'
                      }}</template>
                    </el-table-column>
                    <el-table-column label="税款所属期" prop="dataPeriod" min-width="110" align="center"></el-table-column>
                    <el-table-column label="明细条数" prop="detailCount" min-width="90" align="center"></el-table-column>
                    <el-table-column label="公司主体数" prop="companyCount" min-width="100" align="center"></el-table-column>
                    <el-table-column label="导入文件" min-width="200" align="center" :show-overflow-tooltip="true">
                      <template slot-scope="scope">
                        <template v-if="scope.row.fileUrl">
                          <span class="tax_file_name">{{ scope.row.fileName || taxFileName(scope.row.fileUrl) }}</span>
                          <i class="el-icon-download tax_file_download" title="下载文件" @click="taxDownloadFile(scope.row)"></i>
                        </template>
                        <span v-else>-</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="导入人" prop="importUserName" min-width="100" align="center"></el-table-column>
                    <el-table-column label="导入时间" prop="importTime" min-width="160" align="center"></el-table-column>
                    <el-table-column label="操作" width="180" align="center" fixed="right">
                      <template slot-scope="scope">
                        <div class="injuryTabBtn">
                          <el-button type="text" size="small" @click="taxViewDetail(scope.row)">明细</el-button>
                          <el-popconfirm title="删除将同时删除该批明细，请确认？" @confirm="taxDelete(scope.row)" style="margin:0 10px">
                            <el-button type="text" size="small" slot="reference">删除</el-button>
                          </el-popconfirm>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>

                  <el-pagination v-if="taxPageTotal > 0" background layout="total, sizes, prev, pager, next, jumper" :total="taxPageTotal" :current-page.sync="taxListQuery.PageModel.Page" :page-size.sync="taxListQuery.PageModel.Rows" :page-sizes="[10, 20, 50, 100]" @size-change="taxHandleSizeChange" @current-change="getTaxList()" style="background:#fff; padding:15px; text-align:right"></el-pagination>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="社保基数" name="socialSecurity">
              <!-- ================= 社保基数 ================= -->
              <div class="page_socialSecurityList">
                <div class="topOperation">
                  <div class="top-left">
                    <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px">
                      <el-form-item label="年度" size="small">
                        <el-date-picker v-model="listQuery.year" type="year" value-format="yyyy" placeholder="选择年度" size="small" style="width:130px" clearable></el-date-picker>
                      </el-form-item>
                      <el-form-item label="公司主体" size="small">
                        <el-select v-model="listQuery.companyName" filterable clearable placeholder="请选择公司" size="small" style="width:220px">
                          <el-option v-for="(item, index) in legList" :key="index" :label="item.name" :value="item.name"></el-option>
                        </el-select>
                      </el-form-item>
                      <div class="screenInput">
                        <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
                          <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
                        </el-tooltip>
                      </div>
                    </el-form>
                  </div>
                  <div class="top-right">
                    <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle">搜索</el-button>
                    <el-button v-if="showDropScreen == -1" size="small" plain @click="resetQuery">重置</el-button>
                  </div>
                </div>

                <!-- 高级筛选 -->
                <div class="r_dropDownScreen" v-show="showDropScreen == 1">
                  <div class="pro_down_box">
                    <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px">
                      <div>
                        <el-form-item label="社保缴纳地区" size="small" label-width="127px">
                          <el-input v-model="listQuery.insuranceArea" size="small" clearable style="width:180px" placeholder="请输入地区"></el-input>
                        </el-form-item>
                        <el-form-item label="是否AI补齐" size="small">
                          <el-select v-model="listQuery.isAiCompleted" size="small" clearable placeholder="全部" style="width:180px">
                            <el-option label="是" :value="true"></el-option>
                            <el-option label="否" :value="false"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="更新方式" size="small">
                          <el-select v-model="listQuery.updateMethod" size="small" clearable placeholder="全部" style="width:180px">
                            <el-option label="人工更新" value="人工更新"></el-option>
                            <el-option label="人工导入" value="人工导入"></el-option>
                            <el-option label="自动取数" value="自动取数"></el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </el-form>
                  </div>
                  <div class="drop-footer">
                    <el-button size="small" plain @click="resetQuery()">清空</el-button>
                    <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
                    <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
                  </div>
                </div>

                <!-- 操作按钮 -->
                <div class="ftabBtn flex" style="background:#fff; padding: 10px 15px; border-top: 1px solid #ebeef5;">
                  <el-button type="primary" size="small" @click="handleAdd" style="margin-left:10px">新增</el-button>
                  <el-button type="success" size="small" @click="importExcel" v-preventReClick style="margin-left:10px">导入</el-button>
                  <el-button type="warning" size="small" @click="exporList" v-preventReClick style="margin-left:10px">导出</el-button>
                </div>

                <div class="main-con">
                  <el-table :data="tableData" border class="doc_table" max-height="450px" v-loading="loading" style="width:100%; background:#fff">
                    <el-table-column label="公司主体" prop="companyName" min-width="180" show-overflow-tooltip fixed="left"></el-table-column>
                    <el-table-column label="社保缴纳地区" prop="insuranceArea" min-width="120"></el-table-column>
                    <el-table-column label="年度" prop="year" width="80" align="center"></el-table-column>
                    <el-table-column label="社保基数下限(元)" prop="lowerLimitAmount" width="130" align="right"></el-table-column>
                    <el-table-column label="社保基数上限(元)" prop="upperLimitAmount" width="130" align="right"></el-table-column>
                    <el-table-column label="社保夯实率" prop="consolidationRate" width="100" align="center"></el-table-column>
                    <el-table-column label="生效起始月份" prop="effectiveStartMonth" width="110" align="center"></el-table-column>
                    <el-table-column label="生效结束月份" prop="effectiveEndMonth" width="110" align="center"></el-table-column>
                    <el-table-column label="过渡期规则" prop="transitionRule" width="100" align="center"></el-table-column>
                    <el-table-column label="是否回滚生效" prop="isRollbackEffect" width="100" align="center"></el-table-column>
                    <el-table-column label="实际调整月份" prop="actualAdjustMonth" width="110" align="center"></el-table-column>
                    <el-table-column label="更新方式" prop="updateMethod" width="90" align="center"></el-table-column>
                    <el-table-column label="是否AI补齐" prop="isAiCompleted" width="90" align="center"></el-table-column>
                    <el-table-column label="AI补齐时间" prop="aiCompleteTime" width="150" align="center"></el-table-column>
                    <el-table-column label="备注" prop="remark" min-width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column label="操作" width="150" align="center" fixed="right">
                      <template slot-scope="scope">
                        <div class="injuryTabBtn">
                          <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
                          <el-popconfirm title="请确认是否删除？" @confirm="handleDelete(scope.row)" style="margin:0 10px">
                            <el-button type="text" size="small" slot="reference">删除</el-button>
                          </el-popconfirm>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>

                  <el-pagination v-if="pageTotal > 0" background layout="total, sizes, prev, pager, next, jumper" :total="pageTotal" :current-page.sync="listQuery.PageModel.Page" :page-size.sync="listQuery.PageModel.Rows" :page-sizes="[10, 20, 50, 100]" @size-change="handleSizeChange" @current-change="getList()" style="background:#fff; padding:15px; text-align:right"></el-pagination>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane label="薪资基数" name="salaryBase">
              <!-- ================= 薪资基数 ================= -->
              <div class="page_salaryBase">
                <div class="topOperation">
                  <div class="top-left">
                    <el-form :inline="true" :model="salaryBaseListQuery" class="re_down_form" label-width="90px">
                      <el-form-item label="公司主体" size="small">
                        <el-select v-model="salaryBaseListQuery.companyName" filterable clearable placeholder="请选择" size="small" style="width:180px">
                          <el-option v-for="(item, index) in legList" :key="index" :label="item.name" :value="item.name"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="年度" size="small">
                        <el-date-picker v-model="salaryBaseListQuery.year" type="year" value-format="yyyy" placeholder="选择年度" size="small" style="width:130px" clearable></el-date-picker>
                      </el-form-item>
                      <el-form-item label="姓名" size="small">
                        <el-input v-model="salaryBaseListQuery.name" clearable placeholder="请输入姓名" size="small" style="width:140px"></el-input>
                      </el-form-item>
                      <el-form-item label="证件号码" size="small">
                        <el-input v-model="salaryBaseListQuery.cardId" clearable placeholder="请输入证件号码" size="small" style="width:170px"></el-input>
                      </el-form-item>
                    </el-form>
                  </div>
                  <div class="top-right">
                    <el-button v-preventReClick type="success" size="small" @click="salaryBaseSearch">搜索</el-button>
                    <el-button size="small" plain @click="salaryBaseReset">重置</el-button>
                    <el-button type="primary" size="small" @click="openRefreshSalaryBaseDialog" v-preventReClick>刷新薪资基数表</el-button>
                    <el-button type="warning" size="small" plain @click="salaryBaseExport">导出</el-button>
                  </div>
                </div>

                <div class="main-con">
                  <el-table :data="salaryBaseTableData" border class="doc_table" max-height="450px" v-loading="salaryBaseLoading" style="width:100%; background:#fff">
                    <el-table-column label="年度" prop="year" width="80" align="center" fixed="left"></el-table-column>
                    <el-table-column label="公司主体" prop="companyName" min-width="160" show-overflow-tooltip></el-table-column>
                    <el-table-column label="姓名" prop="name" width="110" align="center"></el-table-column>
                    <el-table-column label="身份证号码" prop="cardId" width="160" align="center"></el-table-column>
                    <el-table-column label="原始薪资（计算值）" prop="originalSalary" width="140" align="right"></el-table-column>
                    <el-table-column label="认定薪资基数" prop="recognizedSalaryBase" width="140" align="right"></el-table-column>
                    <el-table-column label="认定依据" prop="basisType" width="220" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column label="依据月份" prop="basisMonth" width="100" align="center"></el-table-column>
                    <el-table-column label="当时使用的下限" prop="lowerLimitUsed" width="130" align="right"></el-table-column>
                    <el-table-column label="当时使用的上限" prop="upperLimitUsed" width="130" align="right"></el-table-column>
                    <el-table-column label="当时引用的配置ID" prop="configId" width="160" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column label="起始月份" prop="startMonth" width="100" align="center"></el-table-column>
                    <el-table-column label="最后活跃月份" prop="lastActiveMonth" width="110" align="center"></el-table-column>
                    <el-table-column label="更新时间" prop="updateTime" width="150" align="center"></el-table-column>
                    <el-table-column label="更新人" prop="updateUser" width="110" align="center"></el-table-column>
                    <el-table-column label="更新原因" prop="updateReason" min-width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column label="操作" width="80" align="center" fixed="right">
                      <template slot-scope="scope">
                        <div class="injuryTabBtn">
                          <el-button type="text" size="small" @click="salaryBaseEdit(scope.row)">编辑</el-button>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>

                  <el-pagination v-if="salaryBasePageTotal > 0" background layout="total, sizes, prev, pager, next, jumper" :total="salaryBasePageTotal" :current-page.sync="salaryBaseListQuery.PageModel.Page" :page-size.sync="salaryBaseListQuery.PageModel.Rows" :page-sizes="[10, 20, 50, 100]" @size-change="getSalaryBaseList()" @current-change="getSalaryBaseList()" style="background:#fff; padding:15px; text-align:right"></el-pagination>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="700px" :close-on-click-modal="false" :append-to-body="true">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="130px">
        <el-form-item label="公司主体" prop="companyName">
          <el-select v-model="ruleForm.companyName" filterable clearable placeholder="请选择公司" style="width:100%">
            <el-option v-for="(item, index) in legList" :key="index" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="社保缴纳地区">
          <el-input v-model="ruleForm.insuranceArea" placeholder="请输入社保缴纳地区"></el-input>
        </el-form-item>
        <el-form-item label="年度">
          <el-input-number v-model="ruleForm.year" :controls="false" placeholder="请输入年度" style="width:100%"></el-input-number>
        </el-form-item>
        <el-form-item label="社保基数下限(元)">
          <el-input-number v-model="ruleForm.lowerLimitAmount" :controls="false" :min="0" placeholder="请输入下限" style="width:100%"></el-input-number>
        </el-form-item>
        <el-form-item label="社保基数上限(元)">
          <el-input-number v-model="ruleForm.upperLimitAmount" :controls="false" :min="0" placeholder="请输入上限" style="width:100%"></el-input-number>
        </el-form-item>
        <el-form-item label="社保夯实率">
          <el-input v-model="ruleForm.consolidationRate" placeholder="如 70% 或 70"></el-input>
        </el-form-item>
        <el-form-item label="生效起始月份">
          <el-input v-model="ruleForm.effectiveStartMonth" placeholder="如 2024-07"></el-input>
        </el-form-item>
        <el-form-item label="生效结束月份">
          <el-input v-model="ruleForm.effectiveEndMonth" placeholder="如 2025-06，留空表示未定"></el-input>
        </el-form-item>
        <el-form-item label="过渡期规则">
          <el-select v-model="ruleForm.transitionRule" clearable placeholder="请选择" style="width:100%">
            <el-option label="沿用上年" value="沿用上年"></el-option>
            <el-option label="待定" value="待定"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否回滚生效">
          <el-select v-model="ruleForm.isRollbackEffect" clearable placeholder="请选择" style="width:100%">
            <el-option label="是" value="是"></el-option>
            <el-option label="否" value="否"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="实际调整月份">
          <el-input v-model="ruleForm.actualAdjustMonth" placeholder="如 2024-08"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="ruleForm.remark" type="textarea" :rows="2" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="isBtnLoading" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 社保夯实率 锁定/解锁 弹窗（按税款所属期区段） -->
    <el-dialog :title="companyLockType === 1 ? '锁定社保夯实率' : '解锁社保夯实率'" :visible.sync="companyLockDialogVisible" width="420px" :close-on-click-modal="false" :append-to-body="true">
      <div style="margin-bottom: 12px;">{{ companyLockType === 1 ? '锁定' : '解锁' }}指定税款所属期区间的社保夯实率结果：</div>
      <el-form :model="companyLockForm" label-width="120px">
        <el-form-item label="开始税款所属期">
          <el-date-picker v-model="companyLockForm.startTaxPeriod" type="month" placeholder="选择" value-format="yyyyMM" style="width:100%">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束税款所属期">
          <el-date-picker v-model="companyLockForm.endTaxPeriod" type="month" placeholder="选择" value-format="yyyyMM" style="width:100%">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="companyLockDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="companyLockLoading" @click="confirmCompanyLock">确定</el-button>
      </div>
    </el-dialog>

    <!-- 刷新薪资基数表 弹窗（按税款所属期区段） -->
    <el-dialog title="刷新薪资基数表" :visible.sync="refreshSalaryBaseDialogVisible" width="420px" :close-on-click-modal="false" :append-to-body="true">
      <div style="margin-bottom: 12px;">系统将基于指定税款所属期的报税数据和社保账单数据刷新薪资基数：</div>
      <el-form :model="refreshSalaryBaseForm" label-width="120px">
        <el-form-item label="开始税款所属期">
          <el-date-picker v-model="refreshSalaryBaseForm.startTaxPeriod" type="month" placeholder="选择" value-format="yyyyMM" style="width:100%">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束税款所属期">
          <el-date-picker v-model="refreshSalaryBaseForm.endTaxPeriod" type="month" placeholder="选择" value-format="yyyyMM" style="width:100%">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="refreshSalaryBaseDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="refreshSalaryBaseLoading" @click="confirmRefreshSalaryBase">确定</el-button>
      </div>
    </el-dialog>

    <!-- 薪资基数 编辑弹窗 -->
    <el-dialog title="编辑薪资基数" :visible.sync="salaryBaseDialogVisible" width="500px" :close-on-click-modal="false" :append-to-body="true">
      <el-form ref="salaryBaseRuleForm" :model="salaryBaseRuleForm" label-width="130px">
        <el-form-item label="姓名">
          <el-input v-model="salaryBaseRuleForm.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="身份证号码">
          <el-input v-model="salaryBaseRuleForm.cardId" disabled></el-input>
        </el-form-item>
        <el-form-item label="原始薪资（计算值）">
          <el-input-number v-model="salaryBaseRuleForm.originalSalary" :controls="false" :min="0" :precision="2" placeholder="请输入" style="width:100%"></el-input-number>
        </el-form-item>
        <el-form-item label="认定薪资基数">
          <el-input-number v-model="salaryBaseRuleForm.recognizedSalaryBase" :controls="false" :min="0" :precision="2" placeholder="请输入" style="width:100%"></el-input-number>
        </el-form-item>
        <el-form-item label="更新原因">
          <el-input v-model="salaryBaseRuleForm.updateReason" type="textarea" :rows="2" placeholder="请输入更新原因"></el-input>
        </el-form-item>
      </el-form>
      <div style="color:#f56c6c; font-size:12px; margin: 0 0 10px 30px;">修改认定薪资基数后，认定依据自动改为"人工修正"</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="salaryBaseDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="salaryBaseBtnLoading" @click="submitSalaryBaseEdit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 导入弹窗 -->
    <el-dialog title="导入社保基数" :visible.sync="showImport" width="500px" :close-on-click-modal="false" :append-to-body="true">
      <el-form label-width="100px">
        <el-form-item label="下载模板">
          <el-link type="primary" @click="downloadTemp">点击下载导入模板</el-link>
        </el-form-item>
        <el-form-item label="上传Excel">
          <el-upload action="#" :auto-upload="false" :on-change="handleUpload" :on-remove="handleRemove" :limit="1" accept=".xlsx,.xls">
            <el-button size="small" type="primary">选择文件</el-button>
            <div slot="tip" class="el-upload__tip">
              仅支持 .xlsx / .xls 文件；请先下载模板填写后再上传。<br />
              公司主体须存在于法务主体数据源中；以【公司+生效起始月份】为准更新/新增。
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showImport = false">取 消</el-button>
        <el-button type="primary" :loading="isBtnLoading" @click="confirmImport">开始导入</el-button>
      </div>
    </el-dialog>

    <!-- 报税数据导入弹窗 -->
    <el-dialog title="导入报税数据" :visible.sync="showTaxImport" width="520px" :close-on-click-modal="false" :append-to-body="true">
      <el-form label-width="120px">
        <el-form-item label="下载模板">
          <el-link type="primary" @click="taxDownloadTemplate">点击下载导入模板</el-link>
        </el-form-item>
        <el-form-item label="导入类型" required>
          <el-radio-group v-model="taxImportType">
            <el-radio label="MonthImport">按月导入</el-radio>
            <el-radio label="FirstImport">首次导入</el-radio>
          </el-radio-group>
          <div style="color:#909399; font-size:12px; line-height:20px; margin-top:4px;">
            首次导入可不填所属期，按文件内每行税款所属期自动拆分。
          </div>
        </el-form-item>
        <el-form-item label="税款所属期">
          <el-date-picker v-model="taxDataPeriod" placeholder="如 2026-07，首次导入可留空" type="month" value-format="yyyy-MM" size="small" style="width: 240px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="上传申报表">
          <el-upload action="#" :auto-upload="false" :on-change="taxHandleUpload" :on-remove="taxHandleRemove" :limit="1" accept=".xls,.xlsx,.rar">
            <el-button size="small" type="primary">选择文件</el-button>
            <div slot="tip" class="el-upload__tip">
              支持 .xls 及 .rar（.rar 内为多个 .xls，解压后逐个导入）；选择的税款所属期须与文件内一致；公司名须已存在于社保基数表，否则提示补全。
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="重复导入">
          <el-checkbox v-model="taxIsRepeat">允许重复导入（覆盖已存在所属期）</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showTaxImport = false">取 消</el-button>
        <el-button type="primary" :loading="isBtnLoading" @click="taxConfirmImport">开始导入</el-button>
      </div>
    </el-dialog>

    <!-- 报税数据明细弹窗 -->
    <el-dialog :title="'报税数据明细 - ' + currentRecord.batchNo" :visible.sync="showTaxDetail" width="800px" :close-on-click-modal="false" :append-to-body="true">
      <el-table :data="taxDetailList" border v-loading="taxDetailLoading" style="width:100%; max-height:500px">
        <el-table-column label="行号" prop="rowIndex" width="60" align="center"></el-table-column>
        <el-table-column label="公司名称" prop="companyName" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column label="姓名" prop="name" width="100"></el-table-column>
        <el-table-column label="身份证号码" prop="cardId" min-width="170"></el-table-column>
        <el-table-column label="税款所属期" prop="taxPeriod" width="110" align="center"></el-table-column>
        <el-table-column label="税款收入(元)" prop="taxIncome" width="120" align="right"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showTaxDetail = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 生成预测补缴数据弹窗（按人员 tab） -->
    <el-dialog title="生成预测补缴数据" :visible.sync="showForecastSupple" width="480px" :close-on-click-modal="false" :append-to-body="true">
      <el-alert type="warning" :closable="false" style="margin-bottom:16px">
        <template slot="title">
          <span style="font-size:12px;line-height:18px">提醒：此预测补缴数据仅供参考！预测补缴数据是基于已部分地区税务部门提出的上一年度社保夯实率达标要求（未提出的按100%）+当前社保基数上下限进行测算的，后续税务和人社部门会发布本年度的社保夯实率达标要求和社保上下限后请重新计算。</span>
        </template>
      </el-alert>
      <el-form label-width="100px" size="small">
        <el-form-item label="项目：" required>
          <el-select v-model="forecastForm.projectName" filterable clearable placeholder="请选择" style="width:280px" @change="forecastProjectChange">
            <el-option v-for="(item, index) in forecastProjectOptions" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="参保账户：">
          <el-select v-model="forecastForm.insuredAccount" filterable clearable placeholder="请选择（不选=该项目下全部）" style="width:280px" @change="forecastAccountChange">
            <el-option v-for="(item, index) in forecastAccountOptions" :key="index" :label="item" :value="item"></el-option>
          </el-select>
          <div v-if="forecastTargetRate !== null" style="color:#67C23A;font-size:12px;margin-top:4px">
            达标率要求：{{ forecastTargetRate }}%
          </div>
        </el-form-item>
        <el-form-item label="年度：" required>
          <el-select v-model="forecastForm.year" style="width:280px" @change="forecastYearChange">
            <el-option v-for="item in forecastYearOptions" :key="item" :label="item + '年'" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="指定月份：">
          <el-date-picker v-model="forecastForm.startMonth" type="month" placeholder="开始月份" value-format="yyyy-MM" style="width:135px"></el-date-picker>
          <span style="margin:0 4px">-</span>
          <el-date-picker v-model="forecastForm.endMonth" type="month" placeholder="结束月份" value-format="yyyy-MM" style="width:135px"></el-date-picker>
        </el-form-item>
        <el-form-item label="拆分导出：">
          <el-checkbox v-model="forecastForm.splitByAccount">按不同参保账户拆分导出文件</el-checkbox>
          <el-checkbox v-model="forecastForm.splitByProject" style="margin-left:0">按不同项目拆分导出文件</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showForecastSupple = false">取 消</el-button>
        <el-button type="primary" :loading="forecastSuppleLoading" @click="forecastSuppleExport">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  // import Cookies from "js-cookie";
  import xz from "../../common";
  import * as echarts from "echarts";
  import moment from 'moment';
  import checkPermission from '@/utils/permission' // 权限判断函数

  export default {
    name: "basicDataList",
    components: {},
    data() {
      return {
        // 外层/内层 tab（进入「社保夯实率」页面默认落在「驾驶舱」）
        outerTab: "dashboard",
        innerTab: "taxData",
        showDropScreen: -1,
        listQuery: {
          PageModel: {
            Page: 1,
            Rows: 20,
            OrderInput: [{
              property: "createTime",
              order: 1,
            }, ],
          },
          year: String(new Date().getFullYear()),
          companyName: "",
          insuranceArea: "",
          isAiCompleted: null,
          updateMethod: "",
        },
        tableData: [],
        pageTotal: 0,
        loading: false,
        legList: [],
        dialogVisible: false,
        dialogTitle: "新增",
        isBtnLoading: false,
        ruleForm: {
          id: "",
          companyName: "",
          insuranceArea: "",
          year: null,
          lowerLimitAmount: null,
          upperLimitAmount: null,
          effectiveStartMonth: "",
          effectiveEndMonth: "",
          transitionRule: "沿用上年",
          isRollbackEffect: "否",
          actualAdjustMonth: "",
          remark: "",
        },
        rules: {
          companyName: [{
            required: true,
            message: "请选择公司主体",
            trigger: "change"
          }],
        },
        showImport: false,
        importUrl: "",
        // 报税数据
        taxListQuery: {
          PageModel: {
            Page: 1,
            Rows: 20,
            OrderInput: [{
              property: "importTime",
              order: 1,
            }, ],
          },
          importType: "",
          dataPeriod: "",
          importUserName: "",
        },
        taxTableData: [],
        taxPageTotal: 0,
        taxLoading: false,
        showTaxImport: false,
        taxImportType: "MonthImport",
        taxDataPeriod: "",
        taxIsRepeat: false,
        taxImportUrl: "",
        taxImportFileName: "",
        showTaxDetail: false,
        taxDetailList: [],
        taxDetailLoading: false,
        currentRecord: {},
        headPath: this.$store.state.EMP.tablePath,
        // 基础数据列表
        importDetailQuery: {
          PageModel: {
            Page: 1,
            Rows: 20,
            OrderInput: null
          },
          companyName: "",
          projectName: "",
          name: "",
          cardId: "",
          billingMonth: "",
        },
        importDetailTableData: [],
        importDetailPageTotal: 0,
        importDetailLoading: false,
        projectNameOptions: [],
        // 生成预测补缴数据弹窗（按人员 tab）
        showForecastSupple: false,
        forecastSuppleLoading: false,
        forecastForm: {
          projectName: "",
          insuredAccount: "",
          year: String(new Date().getFullYear()),
          startMonth: "",
          endMonth: "",
          splitByAccount: false,
          splitByProject: false,
        },
        forecastProjectOptions: [],
        forecastAccountOptions: [],
        forecastYearOptions: [],
        forecastTargetRate: null,
        // 按项目 tab
        byProjectQuery: {
          projectName: "",
          companyName: "",
          performanceOwner: "",
          servicePerson: "",
          billingMonth: "",
        },
        byProjectTableData: [],
        byProjectSummary: {
          year: null,
          projectCount: 0,
          qualifiedCount: 0,
          unQualifiedCount: 0,
          socialSecurityCount: 0,
          incomeTaxCount: 0,
          socialSecurityTotal: null,
          salaryTotal: null,
          matchRate: null,
        },
        byPersonSummary: {
          personCount: 0,
          matchRate: null,
        },
        byProjectLoading: false,
        // 按服务部门 tab
        byServiceDepartQuery: {
          serviceDepart: "",
          companyName: "",
          billingMonth: "",
        },
        byServiceDepartTableData: [],
        byServiceDepartSummary: {
          year: null,
          serviceDeptCount: 0,
          qualifiedCount: 0,
          unQualifiedCount: 0,
          socialSecurityCount: 0,
          incomeTaxCount: 0,
          socialSecurityTotal: null,
          salaryTotal: null,
          matchRate: null,
        },
        byServiceDepartLoading: false,
        // 按服务部门 tab 服务部门下拉数据源（接口：GetServiceDepartList）
        serviceDepartOptions: [],
        // 按服务部门 tab 公司主体下拉数据源：
        //   未选服务部门 = 与「按公司主体」tab 同源（legList，权限内全部主体）
        //   已选服务部门 = 该部门下的主体（接口：GetCompanyListByServiceDepart）
        byServiceDepartCompanyList: [],
        // 按公司主体 tab（搜索触发，不默认加载）
        byCompanyQuery: {
          companyName: "",
          billingMonth: "",
          annualQualified: "",
        },
        // 按公司主体 tab 全量列表（接口原始返回，前端「是否达标」筛选基于它）
        byCompanyAllData: [],
        byCompanyTableData: [],
        byCompanySummary: {
          companyCount: 0,
          qualifiedCompanyCount: 0,
          unQualifiedCompanyCount: 0,
          socialSecurityTotalCount: 0,
          salaryBaseTotalCount: 0,
          incomeTaxTotalCount: 0,
          matchRate: null,
        },
        byCompanyLoading: false,
        // 社保夯实率 锁定/解锁
        companyLockDialogVisible: false,
        companyLockLoading: false,
        companyLockType: 1,
        companyLockForm: {
          startTaxPeriod: "",
          endTaxPeriod: "",
        },
        // 薪资基数
        salaryBaseListQuery: {
          PageModel: {
            Page: 1,
            Rows: 20,
            OrderInput: [{
              property: "updateTime",
              order: 1,
            }, ],
          },
          year: String(new Date().getFullYear()),
          companyName: "",
          name: "",
          cardId: "",
        },
        salaryBaseTableData: [],
        salaryBasePageTotal: 0,
        salaryBaseLoading: false,
        salaryBaseDialogVisible: false,
        salaryBaseBtnLoading: false,
        // 刷新薪资基数表（按区段）
        refreshSalaryBaseDialogVisible: false,
        refreshSalaryBaseLoading: false,
        refreshSalaryBaseForm: {
          startTaxPeriod: "",
          endTaxPeriod: "",
        },
        salaryBaseRuleForm: {
          id: "",
          name: "",
          cardId: "",
          originalSalary: null,
          recognizedSalaryBase: null,
          updateReason: "",
        },
        // ================= 驾驶舱 =================
        yearOptions: (function () {
          const cur = new Date().getFullYear();
          const arr = [];
          for (let y = cur - 3; y <= cur + 1; y++) arr.push(y);
          return arr;
        })(),
        dashboardQuery: {
          year: String(new Date().getFullYear()),
          month: "",
          province: "",
          companyName: [], // 顶部"公司主体"多选（仅作用于汇总卡/排名看板的主体过滤；已与「按主体」「按服务部门」趋势解耦）
          projectName: [], // 顶部"项目"多选（仅作用于汇总卡/排名看板的项目过滤；已与「按项目」趋势解耦）
          serviceDepart: [], // 服务部门支持多选（按服务部门趋势 → 多服务部门多曲线）
        },
        // 「按主体」趋势的独立主体选择：单独维护，不跟随/不回写顶部"公司主体"下拉(dashboardQuery.companyName)，仅决定按主体趋势曲线
        dashboardTrendCompanies: [],
        // 「按服务部门」趋势的独立主体选择：不跟随/不回写顶部"公司主体"下拉(dashboardQuery.companyName)，
        //   仅决定按服务部门趋势的主体过滤；可选列表见 dashboardDeptCompanyList（随所选服务部门联动）
        dashboardTrendDeptCompanies: [],
        // 「按项目」趋势的独立项目选择：单独维护，不跟随/不回写顶部"项目"下拉(dashboardQuery.projectName)，仅决定按项目趋势曲线
        dashboardTrendProjects: [],
        // 夯实率趋势请求序号：按主体/按服务部门/按项目 三次请求共用，连续切换 tab 或变更选择时丢弃旧响应，只渲染最后一次请求的结果
        dashboardTrendReqSeq: 0,
        // 驾驶舱 tab 公司主体下拉数据源（由 getLegalList 填充）
        dashboardCompanyList: [],
        // 驾驶舱 tab 项目下拉数据源（由 getProjectOptions 填充）
        dashboardProjectList: [],
        // 驾驶舱 tab 服务部门下拉数据源（由 getServiceDepartOptions 填充）
        dashboardServiceDeptList: [],
        // 驾驶舱「按服务部门」tab 下公司主体下拉数据源：未选部门 = 权限内全部主体（dashboardCompanyList 名称）；选中部门 = 该部门下权限内主体（GetCompanyListByServiceDepart）
        dashboardDeptCompanyList: [],
        dashboardSummary: {
          companyTotal: 0,
          qualifiedCompany: 0,
          unQualifiedCompany: 0,
          companyQualifiedRate: "0.0%",
          companyUnQualifiedRate: "0.0%",
          serviceDeptTotal: 0,
          qualifiedServiceDept: 0,
          unQualifiedServiceDept: 0,
          serviceDeptQualifiedRate: "0.0%",
          serviceDeptUnQualifiedRate: "0.0%",
          projectTotal: 0,
          qualifiedProject: 0,
          unQualifiedProject: 0,
          projectQualifiedRate: "0.0%",
          projectUnQualifiedRate: "0.0%",
        },
        dashboardTrendTab: "company", // 默认「按主体」（无总体 tab）
        dashboardTrendRange: "12",
        // 趋势绘图序列：{ name, months, rates }；按主体每主体 1 条，按服务部门/项目每项 1 条
        dashboardTrendSeries: [],
        dashboardChart: null,
        // 趋势图「未达标月份」图例是否选中：选中 → 未达标月份打红空心圈；取消 → 不显示（用户点击图例切换后保持）
        dashboardShowUnQualified: true,
        // 「按主体」tab：统计区间内存在未达标月份的公司主体（按各主体自身 ConsolidationRate 判定）
        dashboardUnQualifiedCompanies: [],
        dashboardRankActive: "company",
        dashboardRankSub: "unQualified",
        dashboardRankPeriod: "",
        dashboardRankLoading: false,
        dashboardRankTable: [],
        // 按钮权限列表
        permissionLists: [],
      };
    },
    created() {
      this.getButtonPower();
      this.getLegalList().then(() => {
        this.loadServiceDepartCompanyOptions();
        // 进入页面默认落在「驾驶舱」tab：首次渲染不会触发 outerTab 的 watch，这里主动初始化驾驶舱（下拉数据已就绪）
        if (this.outerTab === "dashboard") {
          this.initDashboardTab();
        }
      });
      this.getList();
      this.getTaxList();
      // 默认进入即按项目 tab 时，预填"前二个月"作为账单月
      this.byProjectQuery.billingMonth = this.getDefaultBillingMonth();
      // 按公司主体 tab 预填"前二个月"作为账单月（仅预填，点击搜索才查询）
      this.byCompanyQuery.billingMonth = this.getDefaultBillingMonth();
      // 按服务部门 tab 预填"前二个月"作为账单月（仅预填，切到该 tab 时自动查询）
      this.byServiceDepartQuery.billingMonth = this.getDefaultBillingMonth();
      // 按服务部门 tab 服务部门下拉：进入即加载（与「按公司主体」tab 的公司主体下拉一样提前就绪）
      this.loadServiceDepartOptions();
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let d = {
          path: '/basicDataList',
          powerEnName: 'basicDataList'
        }
        xz.getbtnPowerIdBypage(d).then((res) => {
          // console.log('按钮',res)
          if (res.status == "ok") {
            let resmsg = res.msg;
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
            } else {
              this.permissionLists = [];
            }
          } else {
            this.permissionLists = [];
          }
        });
      },
      //判断是否为空(包含0)
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0 ||
          o == "NaN"
        );
      },
      // 前二个月账单月（yyyyMM），如 2026-09 → 202607
      getDefaultBillingMonth() {
        const d = new Date();
        d.setMonth(d.getMonth() - 2);
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, "0");
        return `${y}${m}`;
      },
      // 驾驶舱 tab 初始化：首次进入页面（默认该 tab）与切到该 tab 时共用
      //   驾驶舱筛选下拉：公司主体走 getLegalList；项目走 getProjectOptions（xz.getProjectLists）
      initDashboardTab() {
        if (!this.dashboardCompanyList || this.dashboardCompanyList.length === 0) {
          this.getLegalList();
        }
        if (!this.dashboardProjectList || this.dashboardProjectList.length === 0) {
          this.getProjectOptions();
        }
        this.loadDashboardData();
      },
      outerTabClick() {
        // 切换到按项目 tab 时刷新按项目列表；按公司主体 tab 仅预填账单月，需点击"搜索"才查询
        if (this.outerTab === "byProject") {
          this.getImportStatByProjectList();
        } else if (this.outerTab === "byServiceDepart") {
          // 按服务部门 tab：拉取服务部门/公司主体下拉数据源并自动查询
          this.loadServiceDepartOptions();
          this.loadServiceDepartCompanyOptions();
          this.getImportStatByServiceDeptList();
        } else if (this.outerTab === "byPerson") {
          this.getImportDetailList();
        } else if (this.outerTab === "dashboard") {
          this.initDashboardTab();
        } else if (this.innerTab === "basicData") {
          this.innerT = 'taxData';
          this.innerTabClick()
        }
      },
      innerTabClick() {
        // 切换到对应子 tab 时刷新列表
        if (this.innerTab === "socialSecurity") {
          this.getList();
        } else if (this.innerTab === "taxData") {
          this.getTaxList();
        } else if (this.innerTab === "salaryBase") {
          this.getSalaryBaseList();
        }
      },
      // ================= 报税数据 =================
      // 报税数据列表
      getTaxList() {
        let that = this;
        that.taxLoading = true;
        let data = Object.assign({}, that.taxListQuery);
        xz.ArdCurStat(data, "GetImportRecordPageList").then((res) => {
          that.taxLoading = false;
          // 返回了 pageModel（含 totalCount，即使是 0）即视为查询成功，正常渲染
          if (res && res.data && res.data.pageModel) {
            that.taxTableData = res.data.data || [];
            that.taxPageTotal = res.data.pageModel.totalCount || 0;
          } else if (res && res.status == "ok") {
            that.taxTableData = (res.data && res.data.data) || [];
            that.taxPageTotal = (res.data && res.data.pageModel && res.data.pageModel.totalCount) || 0;
          } else {
            that.$message.error((res && res.msg) || "查询失败");
          }
        });
      },
      taxSearchHandle() {
        this.taxListQuery.PageModel.Page = 1;
        this.getTaxList();
      },
      taxHandleSizeChange(val) {
        this.taxListQuery.PageModel.Page = 1;
        this.taxListQuery.PageModel.Rows = val;
        this.getTaxList();
      },
      taxResetQuery() {
        this.taxListQuery = {
          PageModel: {
            Page: 1,
            Rows: 20,
            OrderInput: [{
              property: "importTime",
              order: 1,
            }, ],
          },
          importType: "",
          dataPeriod: "",
          importUserName: "",
        };
        this.getTaxList();
      },
      // 打开导入弹窗
      taxImportExcel() {
        this.taxImportType = "MonthImport";
        this.taxDataPeriod = "";
        this.taxIsRepeat = false;
        this.taxImportUrl = "";
        this.taxImportFileName = "";
        this.showTaxImport = true;
      },
      // 下载报税数据导入模板
      taxDownloadTemplate() {
        let path = this.headPath + "excel/caa39434-539c-40cb-95d6-31b215f0f9dc/E20260828103632310.xlsx";
        const aTag = document.createElement("a");
        aTag.href = path;
        aTag.click();
      },
      // 上传文件
      taxHandleUpload(file) {
        const formData = new FormData();
        formData.append("pagename", "empexcel");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        // 记住原始文件名，导入时传给后台落库（列表要显示这个原始名称）
        this.taxImportFileName = file.name || "";
        xz.uploadCert(formData).then((res) => {
          this.taxImportUrl = res && res.Url ? res.Url : res;
        });
      },
      taxHandleRemove() {
        this.taxImportUrl = "";
        this.taxImportFileName = "";
      },
      // 提交导入
      taxConfirmImport() {
        if (!this.taxImportUrl) {
          this.$message.warning("请先选择Excel文件");
          return;
        }
        this.isBtnLoading = true;
        let data = {
          url: this.taxImportUrl,
          fileName: this.taxImportFileName || "",
          importType: this.taxImportType,
          dataPeriod: this.taxDataPeriod || "",
          isRepeat: this.taxIsRepeat,
        };
        xz.ArdCurStat(data, "ImportTaxData")
          .then((res) => {
            this.isBtnLoading = false;
            if (res.status == "ok") {
              this.$message.success(res.msg || "导入成功");
              this.showTaxImport = false;
              this.getTaxList();
            } else {
              this.$message.error(res.msg || "导入失败");
            }
          })
          .catch((err) => {
            this.isBtnLoading = false;
            this.$message.error((err && (err.msg || err.message)) || "导入失败");
          });
      },
      // 查看/下载本次导入的原始文件（fileUrl 为上传返回的相对地址，拼上 OSS 前缀）
      taxDownloadFile(row) {
        if (!row || !row.fileUrl) return;
        let path = String(row.fileUrl).replace(/^\//, "");
        let url = /^https?:\/\//i.test(path) ? path : this.headPath + path;
        window.open(url);
      },
      // 取文件地址中的文件名用于列展示
      taxFileName(fileUrl) {
        let name = String(fileUrl || "").split("?")[0].split("/").pop();
        return name || "查看文件";
      },
      // 查看明细
      taxViewDetail(row) {
        this.currentRecord = row;
        this.taxDetailList = [];
        this.showTaxDetail = true;
        this.taxDetailLoading = true;
        let data = {
          id: row.id
        };
        xz.ArdCurStat(data, "GetImportRecordDetailList").then((res) => {
          this.taxDetailLoading = false;
          if (res.status == "ok") {
            this.taxDetailList = (res.data && res.data) || [];
          } else {
            this.$message.error(res.msg || "查询明细失败");
          }
        });
      },
      // 删除导入记录
      taxDelete(row) {
        let data = {
          id: row.id
        };
        xz.ArdCurStat(data, "DeleteImportRecord").then((res) => {
          if (res.status == "ok") {
            this.$message.success("删除成功");
            this.getTaxList();
          } else {
            this.$message.error(res.msg || "删除失败");
          }
        });
      },
      // 获取法务主体（公司）下拉列表（返回 Promise；供「按主体」趋势在列表未就绪时等待后再加载全部主体）
      getLegalList() {
        let that = this;
        let d = {
          userid: Cookies.get("userid-b"),
          companyName: "",
          isCanInsure: false,
          pageNum: 1,
          pageSize: 1000,
        };
        return new Promise((resolve) => {
          xz.ArdCurStat(d, "GetUserLegalList").then((res) => {
            if (res.status == "ok") {
              that.legList = res.data.date;
              that.dashboardCompanyList = res.data.date;
              // 「按服务部门」tab 未选部门时，公司主体下拉默认填充权限内全部主体
              if (that.dashboardTrendTab === "serviceDept" && !(that.dashboardQuery.serviceDepart || []).length &&
                !(that.dashboardDeptCompanyList && that.dashboardDeptCompanyList.length)) {
                that.dashboardDeptCompanyList = (res.data.date || [])
                  .map((c) => c && c.name)
                  .filter((n) => n && String(n).trim());
              }
            } else {
              that.legList = [];
              that.dashboardCompanyList = [];
            }
            resolve();
          }).catch(() => {
            that.legList = [];
            that.dashboardCompanyList = [];
            resolve();
          });
        });
      },
      // 获取项目下拉列表（xz.getProjectLists，供驾驶舱"项目"筛选控件绑定）
      getProjectOptions() {
        let that = this;
        let d = {
          projectname: "",
          projectid: "",
          custname: "",
          strBusiStat: "",
          currpage: 1,
          perpage: 10000000,
          strorgancode: localStorage.gancode || "",
          roletype: localStorage.loginRoletype,
        };
        xz.getProjectLists(d).then((res) => {
          if (res.status == "ok") {
            that.dashboardProjectList = res.msg || [];
          } else {
            that.dashboardProjectList = [];
          }
        });
      },
      // 列表查询
      getList() {
        let that = this;
        that.loading = true;
        let data = Object.assign({}, that.listQuery);
        xz.ArdCurStat(data, "GetSocialSecurityBasePageList").then((res) => {
          that.loading = false;
          if (res.status == "ok") {
            that.tableData = (res.data && res.data.data) || [];
            that.pageTotal = (res.data && res.data.pageModel && res.data.pageModel.totalCount) || 0;
          } else {
            that.$message.error(res.msg || "查询失败");
          }
        });
      },
      searchHandle() {
        this.listQuery.PageModel.Page = 1;
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.PageModel.Page = 1;
        this.listQuery.PageModel.Rows = val;
        this.getList();
      },
      resetQuery() {
        this.listQuery = {
          PageModel: {
            Page: 1,
            Rows: 20,
            OrderInput: [{
              property: "createTime",
              order: 1,
            }, ],
          },
          year: String(new Date().getFullYear()),
          companyName: "",
          insuranceArea: "",
          isAiCompleted: null,
          updateMethod: "",
        };
        this.getList();
      },
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      handleAdd() {
        this.dialogTitle = "新增";
        this.ruleForm = {
          id: "",
          companyName: "",
          insuranceArea: "",
          year: null,
          lowerLimitAmount: null,
          upperLimitAmount: null,
          consolidationRate: "",
          effectiveStartMonth: "",
          effectiveEndMonth: "",
          transitionRule: "沿用上年",
          isRollbackEffect: "否",
          actualAdjustMonth: "",
          remark: "",
        };
        this.dialogVisible = true;
      },
      handleEdit(row) {
        this.dialogTitle = "编辑";
        this.ruleForm = {
          id: row.id,
          companyName: row.companyName,
          insuranceArea: row.insuranceArea,
          year: row.year,
          lowerLimitAmount: row.lowerLimitAmount,
          upperLimitAmount: row.upperLimitAmount,
          consolidationRate: row.consolidationRate || "",
          effectiveStartMonth: row.effectiveStartMonth,
          effectiveEndMonth: row.effectiveEndMonth,
          transitionRule: row.transitionRule,
          isRollbackEffect: row.isRollbackEffect,
          actualAdjustMonth: row.actualAdjustMonth,
          remark: row.remark,
        };
        this.dialogVisible = true;
      },
      handleDelete(row) {
        let data = {
          id: row.id,
          isDelete: "1",
        };
        xz.ArdCurStat(data, "AddDelUpSocialSecurityBase").then((res) => {
          if (res.status == "ok") {
            this.$message.success("删除成功");
            this.getList();
          } else {
            this.$message.error(res.msg || "删除失败");
          }
        });
      },
      submitForm() {
        let that = this;
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            that.isBtnLoading = true;
            let data = Object.assign({}, that.ruleForm);
            xz.ArdCurStat(data, "AddDelUpSocialSecurityBase").then((res) => {
              that.isBtnLoading = false;
              if (res.status == "ok") {
                that.$message.success(res.msg || "保存成功");
                that.dialogVisible = false;
                that.getList();
              } else {
                that.$message.error(res.msg || "保存失败");
              }
            });
          }
        });
      },
      // 导入
      importExcel() {
        this.importUrl = "";
        this.showImport = true;
      },
      // 下载导入模板
      downloadTemp() {
        let path = this.headPath + "excel/024dc6c2-99e3-41f6-b847-438a2d2795fd/E20260826161232725.xlsx";
        const aTag = document.createElement("a");
        aTag.href = path;
        aTag.click();
      },

      // ================= 基础数据列表 =================
      // 百分比格式化（后端返回的是比率 0.8540，显示 85.40%）
      formatPercent(val) {
        if (val === null || val === undefined || val === "") return "-";
        const num = Number(val);
        if (isNaN(num)) return "-";
        return (num * 100).toFixed(2) + "%";
      },
      // 年度基数夯实率列：黄色背景高亮
      rateCellStyle({
        row,
        column
      }) {
        if (column.property === "annualBaseConsolidationRate") {
          return "background:#fff7a8;";
        }
        return "";
      },
      // 查询基础数据列表
      getImportDetailList() {
        let that = this;
        that.importDetailLoading = true;
        let data = Object.assign({}, that.importDetailQuery);
        // billingMonth 为空时传 null，避免空字符串传到后端
        if (!data.billingMonth) data.billingMonth = null;
        if (!data.companyName) data.companyName = null;
        if (!data.projectName) data.projectName = null;
        if (!data.name) data.name = null;
        if (!data.cardId) data.cardId = null;
        xz.ArdCurStat(data, "GetImportDetailPageList").then((res) => {
          that.importDetailLoading = false;
          // 返回结构：res.data = { data: [...], pageModel }
          if (res && res.data) {
            const d = res.data;
            // 兼容两种结构：res.data 直接是对象（含 pageModel）；或 res.data 是数组
            that.byPersonSummary = d.summary || {
              personCount: 0,
              matchRate: null
            };
            that.byPersonSummary.year = that.importDetailQuery.billingMonth.substring(0, 4) || null;
            if (d.pageModel) {
              that.importDetailTableData = d.data || [];
              that.importDetailPageTotal = d.pageModel.totalCount || 0;
            } else if (res.status == "ok" && d.data && d.data.pageModel) {
              that.importDetailTableData = d.data.data || [];
              that.importDetailPageTotal = d.data.pageModel.totalCount || 0;
            } else {
              that.importDetailTableData = [];
              that.importDetailPageTotal = 0;
            }
          } else {
            that.$message.error((res && res.msg) || "查询失败");
          }
        }).catch((err) => {
          that.importDetailLoading = false;
          that.$message.error((err && (err.msg || err.message)) || "查询失败");
        });
      },
      importDetailSearch() {
        this.importDetailQuery.PageModel.Page = 1;
        this.getImportDetailList();
      },
      importDetailReset() {
        this.importDetailQuery.companyName = "";
        this.importDetailQuery.projectName = "";
        this.importDetailQuery.name = "";
        this.importDetailQuery.cardId = "";
        this.importDetailQuery.billingMonth = "";
        this.importDetailQuery.PageModel.Page = 1;
        this.getImportDetailList();
      },
      importDetailExport() {
        let that = this;
        let data = Object.assign({}, that.importDetailQuery);
        if (!data.billingMonth) data.billingMonth = null;
        if (!data.companyName) data.companyName = null;
        if (!data.projectName) data.projectName = null;
        if (!data.name) data.name = null;
        if (!data.cardId) data.cardId = null;
        data.PageModel.Page = 1;
        data.PageModel.Rows = 10000;
        xz.ArdCurStatExp(data, "EGetImportDetailPageList").then((res) => {
          try {
            var blob = new Blob([res]);
            var downloadUrl = window.URL.createObjectURL(blob);
            var anchor = document.createElement("a");
            anchor.href = downloadUrl;
            anchor.download = "按人员列表.xlsx";
            anchor.click();
            window.URL.revokeObjectURL(downloadUrl);
          } catch (e) {
            that.$message.error("导出异常");
          }
        });
      },
      // ================= 生成预测补缴数据（按人员 tab） =================
      // 打开弹窗：只加载项目下拉（后端按用户缓存 5 分钟），参保账户等选了项目再加载
      openForecastSupple() {
        let that = this;
        that.showForecastSupple = true;
        // 年度选项：当前年度往前推 4 年
        let curYear = new Date().getFullYear();
        that.forecastYearOptions = [];
        for (let y = curYear; y >= curYear - 4; y--) that.forecastYearOptions.push(String(y));
        that.forecastTargetRate = null;
        that.loadForecastProjects();
      },
      // 项目下拉（单独接口，后端缓存 5 分钟）
      loadForecastProjects() {
        let that = this;
        xz.ArdCurStat({}, "GetForecastSuppleProjects").then((res) => {
          if (res && res.status == "ok" && res.data) {
            that.forecastProjectOptions = res.data || [];
          } else {
            that.forecastProjectOptions = [];
          }
        }).catch(() => {
          that.forecastProjectOptions = [];
        });
      },
      // 切换项目：清空已选账户/达标率，再加载该项目下的参保账户（单独接口）
      forecastProjectChange() {
        let that = this;
        that.forecastForm.insuredAccount = "";
        that.forecastTargetRate = null;
        that.forecastAccountOptions = [];
        if (!that.forecastForm.projectName) return;
        xz.ArdCurStat({
          projectName: that.forecastForm.projectName,
        }, "GetForecastSuppleAccounts").then((res) => {
          if (res && res.status == "ok" && res.data) {
            that.forecastAccountOptions = res.data || [];
          } else {
            that.forecastAccountOptions = [];
          }
        }).catch(() => {
          that.forecastAccountOptions = [];
        });
      },
      // 选中参保账户 / 切换年度后：显示该法务主体的达标率要求
      forecastAccountChange() {
        this.loadForecastTargetRate();
      },
      forecastYearChange() {
        this.loadForecastTargetRate();
      },
      loadForecastTargetRate() {
        let that = this;
        that.forecastTargetRate = null;
        if (!that.forecastForm.insuredAccount || !that.forecastForm.year) return;
        xz.ArdCurStat({
          insuredAccount: that.forecastForm.insuredAccount,
          year: that.forecastForm.year,
        }, "GetForecastSuppleTargetRate").then((res) => {
          if (res && res.status == "ok" && res.data !== null && res.data !== undefined) {
            that.forecastTargetRate = res.data;
          }
        }).catch(() => {});
      },
      // 确定：生成并下载 Excel（每个分组一个 sheet）
      forecastSuppleExport() {
        let that = this;
        // 项目、年度必填；参保账户非必填（不选 = 该项目下的全部参保账户）
        if (!that.forecastForm.projectName) { that.$message.warning("请选择项目"); return; }
        if (!that.forecastForm.year) { that.$message.warning("请选择年度"); return; }
        that.forecastSuppleLoading = true;
        let data = {
          projectName: that.forecastForm.projectName,
          insuredAccount: that.forecastForm.insuredAccount || null,
          year: that.forecastForm.year,
          startMonth: that.forecastForm.startMonth || null,
          endMonth: that.forecastForm.endMonth || null,
          splitByAccount: that.forecastForm.splitByAccount,
          splitByProject: that.forecastForm.splitByProject,
        };
        xz.ArdCurStatExp(data, "ExportForecastSupple").then((res) => {
          that.forecastSuppleLoading = false;
          // 后端报错（如没有可预测的数据）时返回的是 JSON 错误信息而不是 Excel，识别后直接提示
          if (res && res.type && (res.type.indexOf("application/json") > -1 || res.type.indexOf("text/html") > -1)) {
            let reader = new FileReader();
            reader.onload = () => {
              let msg = "生成预测补缴数据失败";
              try { msg = JSON.parse(reader.result).msg || msg; } catch (e) { }
              that.$message.error(msg);
            };
            reader.readAsText(res);
            return;
          }
          try {
            var blob = new Blob([res]);
            var downloadUrl = window.URL.createObjectURL(blob);
            var anchor = document.createElement("a");
            anchor.href = downloadUrl;
            anchor.download = "预测补缴数据.xlsx";
            anchor.click();
            window.URL.revokeObjectURL(downloadUrl);
            that.showForecastSupple = false;
          } catch (e) {
            that.$message.error("导出异常");
          }
        }).catch((err) => {
          that.forecastSuppleLoading = false;
          that.$message.error((err && (err.msg || err.message)) || "生成预测补缴数据失败");
        });
      },
      // ================= 按项目 tab =================
      // 查询按项目统计
      getImportStatByProjectList() {
        let that = this;
        that.byProjectLoading = true;
        let data = {
          projectName: that.byProjectQuery.projectName || null,
          companyName: that.byProjectQuery.companyName || null,
          billingMonth: that.byProjectQuery.billingMonth || null,
        };
        xz.ArdCurStat(data, "GetImportStatByProjectList").then((res) => {
          that.byProjectLoading = false;
          if (res && res.status == "ok" && res.data) {
            const d = res.data;
            that.byProjectTableData = d.data || [];
            that.byProjectSummary = d.summary || {
              year: null,
              projectCount: 0,
              qualifiedCount: 0,
              unQualifiedCount: 0,
              socialSecurityCount: 0,
              incomeTaxCount: 0,
              matchRate: null
            };
            // 年度优先取后端汇总（按税款所属期），回退当前查询条件
            that.byProjectSummary.year = that.byProjectSummary.year ||
              (that.byProjectQuery.billingMonth ? String(that.byProjectQuery.billingMonth).substring(0, 4) : null);
          } else if (res && res.data) {
            // 兼容 res.data 是 { data, summary }
            that.byProjectTableData = res.data.data || [];
            that.byProjectSummary = res.data.summary || {
              year: null,
              projectCount: 0,
              qualifiedCount: 0,
              unQualifiedCount: 0,
              socialSecurityCount: 0,
              incomeTaxCount: 0,
              matchRate: null
            };
            that.byProjectSummary.year = that.byProjectSummary.year ||
              (that.byProjectQuery.billingMonth ? String(that.byProjectQuery.billingMonth).substring(0, 4) : null);
          } else {
            that.byProjectTableData = [];
            that.byProjectSummary = {
              year: null,
              projectCount: 0,
              qualifiedCount: 0,
              unQualifiedCount: 0,
              socialSecurityCount: 0,
              incomeTaxCount: 0,
              matchRate: null
            };
            that.$message.error((res && res.msg) || "查询失败");
          }
        }).catch((err) => {
          that.byProjectLoading = false;
          that.byProjectTableData = [];
          that.byProjectSummary = {
            year: null,
            projectCount: 0,
            qualifiedCount: 0,
            unQualifiedCount: 0,
            socialSecurityCount: 0,
            incomeTaxCount: 0,
            matchRate: null
          };
          that.$message.error((err && (err.msg || err.message)) || "查询失败");
        });
      },
      byProjectSearch() {
        this.getImportStatByProjectList();
      },
      byProjectReset() {
        this.byProjectQuery = {
          projectName: "",
          companyName: "",
          performanceOwner: "",
          servicePerson: "",
          billingMonth: this.getDefaultBillingMonth(),
        };
        this.getImportStatByProjectList();
      },
      byProjectExport() {
        let that = this;
        let data = {
          projectName: that.byProjectQuery.projectName || null,
          companyName: that.byProjectQuery.companyName || null,
          billingMonth: that.byProjectQuery.billingMonth || null,
        };
        xz.ArdCurStatExp(data, "EGetImportStatByProjectList").then((res) => {
          try {
            var blob = new Blob([res]);
            var downloadUrl = window.URL.createObjectURL(blob);
            var anchor = document.createElement("a");
            anchor.href = downloadUrl;
            anchor.download = "按项目统计.xlsx";
            anchor.click();
            window.URL.revokeObjectURL(downloadUrl);
          } catch (e) {
            that.$message.error("导出异常");
          }
        });
      },
      // 跳转按人员 tab 查看明细
      byProjectViewDetail(row) {
        this.outerTab = "byPerson";
        this.importDetailQuery.projectName = row.projectName || "";
        this.importDetailQuery.companyName = row.companyName || "";
        this.importDetailQuery.billingMonth = row.taxPeriod || this.importDetailQuery.billingMonth;
        this.$nextTick(() => {
          this.getImportDetailList();
        });
      },
      // ================= 按服务部门 tab =================
      // 服务部门下拉数据源（接口：GetServiceDepartList，取明细表 ServiceDepart 去重非空集合）
      loadServiceDepartOptions() {
        let that = this;
        if (that.serviceDepartOptions && that.serviceDepartOptions.length) return;
        xz.ArdCurStat({
          CompanyNames: []
        }, "GetServiceDepartList").then((res) => {
          if (res && res.status === "ok" && res.data && res.data.data) {
            that.serviceDepartOptions = res.data.data || [];
          } else {
            that.serviceDepartOptions = [];
          }
        }).catch(() => {
          that.serviceDepartOptions = [];
        });
      },
      // 「按服务部门」tab 公司主体下拉数据源：
      //   未选服务部门 → 与「按公司主体」tab 同源（legList，数据权限内的全部主体）
      //   已选服务部门 → 该部门下的主体（接口：GetCompanyListByServiceDepart，同样受数据权限约束）
      // clearIfMissing：联动切换服务部门后，若已选主体不在新列表中则清空
      loadServiceDepartCompanyOptions(clearIfMissing) {
        let that = this;
        const allNames = (that.legList || [])
          .map((c) => c && c.name)
          .filter((n) => n && String(n).trim());
        const dept = that.byServiceDepartQuery.serviceDepart;
        const applyList = (list) => {
          that.byServiceDepartCompanyList = list || [];
          if (clearIfMissing) {
            const selected = that.byServiceDepartQuery.companyName;
            if (selected && (that.byServiceDepartCompanyList || []).indexOf(selected) === -1) {
              that.byServiceDepartQuery.companyName = "";
            }
          }
        };
        if (!dept) {
          applyList(allNames);
          return;
        }
        xz.ArdCurStat({
          ServiceDeparts: [dept]
        }, "GetCompanyListByServiceDepart").then((res) => {
          if (res && res.status === "ok" && res.data && res.data.data) {
            applyList(res.data.data || []);
          } else {
            applyList(allNames);
          }
        }).catch(() => {
          applyList(allNames);
        });
      },
      // 服务部门变更（「按服务部门」数据 tab）：刷新公司主体下拉（并按需清掉已失效的已选主体）
      // 注意：方法名不能与驾驶舱「按服务部门」子 tab 的 onServiceDepartChange 重名，否则会被后者覆盖导致联动失效并误触发驾驶舱查询
      onByServiceDepartChange() {
        this.loadServiceDepartCompanyOptions(true);
      },
      // 查询按服务部门统计
      getImportStatByServiceDeptList() {
        let that = this;
        that.byServiceDepartLoading = true;
        let data = {
          serviceDepart: that.byServiceDepartQuery.serviceDepart || null,
          companyName: that.byServiceDepartQuery.companyName || null,
          billingMonth: that.byServiceDepartQuery.billingMonth || null,
        };
        xz.ArdCurStat(data, "GetImportStatByServiceDeptList").then((res) => {
          that.byServiceDepartLoading = false;
          if (res && res.status == "ok" && res.data) {
            const d = res.data;
            that.byServiceDepartTableData = d.data || [];
            that.byServiceDepartSummary = d.summary || {
              year: null,
              serviceDeptCount: 0,
              qualifiedCount: 0,
              unQualifiedCount: 0,
              socialSecurityCount: 0,
              incomeTaxCount: 0,
              matchRate: null
            };
            // 年度优先取后端汇总（按税款所属期），回退当前查询条件
            that.byServiceDepartSummary.year = that.byServiceDepartSummary.year ||
              (that.byServiceDepartQuery.billingMonth ? String(that.byServiceDepartQuery.billingMonth).substring(0, 4) : null);
          } else if (res && res.data) {
            // 兼容 res.data 是 { data, summary }
            that.byServiceDepartTableData = res.data.data || [];
            that.byServiceDepartSummary = res.data.summary || {
              year: null,
              serviceDeptCount: 0,
              qualifiedCount: 0,
              unQualifiedCount: 0,
              socialSecurityCount: 0,
              incomeTaxCount: 0,
              matchRate: null
            };
            that.byServiceDepartSummary.year = that.byServiceDepartSummary.year ||
              (that.byServiceDepartQuery.billingMonth ? String(that.byServiceDepartQuery.billingMonth).substring(0, 4) : null);
          } else {
            that.byServiceDepartTableData = [];
            that.byServiceDepartSummary = {
              year: null,
              serviceDeptCount: 0,
              qualifiedCount: 0,
              unQualifiedCount: 0,
              socialSecurityCount: 0,
              incomeTaxCount: 0,
              matchRate: null
            };
            that.$message.error((res && res.msg) || "查询失败");
          }
        }).catch((err) => {
          that.byServiceDepartLoading = false;
          that.byServiceDepartTableData = [];
          that.byServiceDepartSummary = {
            year: null,
            serviceDeptCount: 0,
            qualifiedCount: 0,
            unQualifiedCount: 0,
            socialSecurityCount: 0,
            incomeTaxCount: 0,
            matchRate: null
          };
          that.$message.error((err && (err.msg || err.message)) || "查询失败");
        });
      },
      byServiceDepartSearch() {
        this.getImportStatByServiceDeptList();
      },
      byServiceDepartReset() {
        this.byServiceDepartQuery = {
          serviceDepart: "",
          companyName: "",
          billingMonth: this.getDefaultBillingMonth(),
        };
        // 服务部门已清空 → 公司主体下拉恢复为数据权限内全部主体
        this.loadServiceDepartCompanyOptions();
        this.getImportStatByServiceDeptList();
      },
      byServiceDepartExport() {
        let that = this;
        let data = {
          serviceDepart: that.byServiceDepartQuery.serviceDepart || null,
          companyName: that.byServiceDepartQuery.companyName || null,
          billingMonth: that.byServiceDepartQuery.billingMonth || null,
        };
        xz.ArdCurStatExp(data, "EGetImportStatByServiceDeptList").then((res) => {
          try {
            var blob = new Blob([res]);
            var downloadUrl = window.URL.createObjectURL(blob);
            var anchor = document.createElement("a");
            anchor.href = downloadUrl;
            anchor.download = "按服务部门统计.xlsx";
            anchor.click();
            window.URL.revokeObjectURL(downloadUrl);
          } catch (e) {
            that.$message.error("导出异常");
          }
        });
      },
      // 跳转按人员 tab 查看明细（按人员 tab 无服务部门筛选，故仅带公司主体+税款所属期）
      byServiceDepartViewDetail(row) {
        this.outerTab = "byPerson";
        this.importDetailQuery.projectName = "";
        this.importDetailQuery.companyName = row.companyName || "";
        this.importDetailQuery.billingMonth = row.taxPeriod || this.importDetailQuery.billingMonth;
        this.$nextTick(() => {
          this.getImportDetailList();
        });
      },
      // ================= 按公司主体 tab =================
      // 查询按公司主体统计（点击"搜索"才触发，不默认加载）
      getImportStatByCompanyList() {
        let that = this;
        that.byCompanyLoading = true;
        let data = {
          companyName: that.byCompanyQuery.companyName || null,
          billingMonth: that.byCompanyQuery.billingMonth || null,
        };
        xz.ArdCurStat(data, "GetImportStatByCompanyList").then((res) => {
          that.byCompanyLoading = false;
          if (res && res.status == "ok" && res.data) {
            const d = res.data;
            that.byCompanyAllData = d.data || [];
            that.filterByCompanyData();
            that.byCompanySummary = d.summary || {
              year: null,
              companyCount: 0,
              qualifiedCompanyCount: 0,
              unQualifiedCompanyCount: 0,
              socialSecurityTotalCount: 0,
              salaryBaseTotalCount: 0,
              incomeTaxTotalCount: 0,
              matchRate: null,
            };
            // 年度优先取后端汇总（按税款所属期），回退当前查询条件
            that.byCompanySummary.year = that.byCompanySummary.year ||
              (that.byCompanyQuery.billingMonth ? String(that.byCompanyQuery.billingMonth).substring(0, 4) : null);
            that.byCompanySummary.updateTime = moment().format("YYYY-MM-DD HH:mm:ss");
          } else if (res && res.data) {
            // 兼容 res.data 是 { data, summary }
            that.byCompanyAllData = res.data.data || [];
            that.filterByCompanyData();
            that.byCompanySummary = res.data.summary || {
              companyCount: 0,
              qualifiedCompanyCount: 0,
              unQualifiedCompanyCount: 0,
              socialSecurityTotalCount: 0,
              salaryBaseTotalCount: 0,
              incomeTaxTotalCount: 0,
              matchRate: null,
            };
            that.byCompanySummary.year = that.byCompanySummary.year ||
              (that.byCompanyQuery.billingMonth ? String(that.byCompanyQuery.billingMonth).substring(0, 4) : null);
            that.byCompanySummary.updateTime = moment().format("YYYY-MM-DD HH:mm:ss");
          } else {
            that.byCompanyAllData = [];
            that.byCompanyTableData = [];
            that.byCompanySummary = {
              companyCount: 0,
              qualifiedCompanyCount: 0,
              unQualifiedCompanyCount: 0,
              socialSecurityTotalCount: 0,
              salaryBaseTotalCount: 0,
              incomeTaxTotalCount: 0,
              matchRate: null,
              year: null,
              updateTime: '-',
            };
            that.$message.error((res && res.msg) || "查询失败");
          }
        }).catch((err) => {
          that.byCompanyLoading = false;
          that.byCompanyAllData = [];
          that.byCompanyTableData = [];
          that.byCompanySummary = {
            companyCount: 0,
            qualifiedCompanyCount: 0,
            unQualifiedCompanyCount: 0,
            socialSecurityTotalCount: 0,
            salaryBaseTotalCount: 0,
            incomeTaxTotalCount: 0,
            matchRate: null,
            year: null,
            updateTime: '-',
          };
          that.$message.error((err && (err.msg || err.message)) || "查询失败");
        });
      },
      byCompanySearch() {
        this.getImportStatByCompanyList();
      },
      byCompanyReset() {
        this.byCompanyQuery = {
          companyName: "",
          billingMonth: this.getDefaultBillingMonth(),
          annualQualified: "",
        };
        this.filterByCompanyData();
      },
      // 前端筛选：按「是否达标」过滤已加载的按公司主体列表（不重新请求接口）
      filterByCompanyData() {
        const q = this.byCompanyQuery.annualQualified;
        if (!q) {
          this.byCompanyTableData = this.byCompanyAllData;
        } else {
          this.byCompanyTableData = this.byCompanyAllData.filter((r) => r.annualQualified === q);
        }
      },
      // 「是否达标」下拉变化：前端过滤按公司主体列表
      auqChange() {
        this.filterByCompanyData();
      },
      byCompanyExport() {
        let that = this;
        let data = {
          companyName: that.byCompanyQuery.companyName || null,
          billingMonth: that.byCompanyQuery.billingMonth || null,
        };
        xz.ArdCurStatExp(data, "EGetImportStatByCompanyList").then((res) => {
          try {
            var blob = new Blob([res]);
            var downloadUrl = window.URL.createObjectURL(blob);
            var anchor = document.createElement("a");
            anchor.href = downloadUrl;
            anchor.download = "按公司主体统计.xlsx";
            anchor.click();
            window.URL.revokeObjectURL(downloadUrl);
          } catch (e) {
            that.$message.error("导出异常");
          }
        });
      },
      // 社保夯实率 锁定/解锁（按税款所属期区间）
      openCompanyLockDialog(lockType) {
        // 默认区间：当年1月 到 "上二个月"账单月（可自行修改）
        const year = new Date().getFullYear();
        this.companyLockType = lockType === 1 ? 1 : 0;
        this.companyLockForm = {
          startTaxPeriod: `${year}01`,
          endTaxPeriod: this.getDefaultBillingMonth(),
        };
        this.companyLockDialogVisible = true;
      },
      confirmCompanyLock() {
        let that = this;
        const start = (that.companyLockForm.startTaxPeriod || "").trim();
        const end = (that.companyLockForm.endTaxPeriod || "").trim();
        if (!start || !end) {
          that.$message.warning("请选择开始与结束税款所属期");
          return;
        }
        if (start > end) {
          that.$message.warning("结束税款所属期不能早于开始税款所属期");
          return;
        }
        that.companyLockLoading = true;
        xz.ArdCurStat({
          startTaxPeriod: start,
          endTaxPeriod: end,
          lockType: that.companyLockType,
        }, "SaveCompanyLock").then((res) => {
          that.companyLockLoading = false;
          if (res && res.status == "ok") {
            that.companyLockDialogVisible = false;
            that.$message.success((that.companyLockType === 1 ? "锁定" : "解锁") + "成功");
            // 锁定/解锁作用于税款所属期区间，刷新列表即可看到"锁定状态"列变化
            that.getImportStatByCompanyList();
          } else {
            that.$message.error((res && res.msg) || "操作失败");
          }
        }).catch((err) => {
          that.companyLockLoading = false;
          that.$message.error((err && (err.msg || err.message)) || "操作失败");
        });
      },
      // 金额格式化（保留 2 位小数，空值显示 -）
      formatMoney(val) {
        if (val === null || val === undefined || val === "") return "-";
        const n = Number(val);
        if (isNaN(n)) return "-";
        return n.toFixed(2);
      },
      // ================= 薪资基数 =================
      // 薪资基数列表
      getSalaryBaseList() {
        let that = this;
        that.salaryBaseLoading = true;
        let data = Object.assign({}, that.salaryBaseListQuery);
        if (!data.year) data.year = null;
        if (!data.companyName) data.companyName = null;
        if (!data.name) data.name = null;
        if (!data.cardId) data.cardId = null;
        xz.ArdCurStat(data, "GetSalaryBaseVerifyPageList").then((res) => {
          that.salaryBaseLoading = false;
          if (res && res.data && res.data.data) {
            that.salaryBaseTableData = res.data.data || [];
            that.salaryBasePageTotal = (res.data.pageModel && res.data.pageModel.totalCount) || 0;
          } else if (res && res.status == "ok") {
            that.salaryBaseTableData = (res.data && res.data.data) || [];
            that.salaryBasePageTotal = (res.data && res.data.pageModel && res.data.pageModel.totalCount) || 0;
          } else {
            that.$message.error((res && res.msg) || "查询失败");
          }
        });
      },
      salaryBaseSearch() {
        this.salaryBaseListQuery.PageModel.Page = 1;
        this.getSalaryBaseList();
      },
      salaryBaseReset() {
        this.salaryBaseListQuery = {
          PageModel: {
            Page: 1,
            Rows: 20,
            OrderInput: [{
              property: "updateTime",
              order: 1,
            }, ],
          },
          year: String(new Date().getFullYear()),
          companyName: "",
          name: "",
          cardId: "",
        };
        this.getSalaryBaseList();
      },
      salaryBaseExport() {
        let that = this;
        let data = Object.assign({}, that.salaryBaseListQuery);
        if (!data.year) data.year = null;
        if (!data.companyName) data.companyName = null;
        if (!data.name) data.name = null;
        if (!data.cardId) data.cardId = null;
        data.PageModel.Page = 1;
        data.PageModel.Rows = 10000;
        xz.ArdCurStatExp(data, "EGetSalaryBaseVerifyPageList").then((res) => {
          try {
            var blob = new Blob([res]);
            var downloadUrl = window.URL.createObjectURL(blob);
            var anchor = document.createElement("a");
            anchor.href = downloadUrl;
            anchor.download = "薪资基数核定.xlsx";
            anchor.click();
            window.URL.revokeObjectURL(downloadUrl);
          } catch (e) {
            that.$message.error("导出异常");
          }
        });
      },
      // ================= 刷新薪资基数表（按区段） =================
      openRefreshSalaryBaseDialog() {
        // 默认开始 = 当年1月；结束 = 上二个月账单月
        const now = new Date();
        const year = now.getFullYear();
        const defaultStart = `${year}01`;
        const defaultEnd = this.getDefaultBillingMonth();
        this.refreshSalaryBaseForm = {
          startTaxPeriod: defaultStart,
          endTaxPeriod: defaultEnd,
        };
        this.refreshSalaryBaseDialogVisible = true;
      },
      confirmRefreshSalaryBase() {
        let that = this;
        const start = (that.refreshSalaryBaseForm.startTaxPeriod || "").trim();
        const end = (that.refreshSalaryBaseForm.endTaxPeriod || "").trim();
        if (!start || !end) {
          that.$message.warning("请选择开始与结束税款所属期");
          return;
        }
        if (start > end) {
          that.$message.warning("结束税款所属期不能早于开始税款所属期");
          return;
        }
        // 估算月份差：避免单次超过 36 个月
        const months = (parseInt(end.substring(0, 4)) - parseInt(start.substring(0, 4))) * 12 +
          (parseInt(end.substring(4, 6)) - parseInt(start.substring(4, 6))) + 1;
        if (months > 36) {
          that.$message.warning("单次刷新区间不能超过 36 个月，请分批处理");
          return;
        }

        that.$confirm(
          `将刷新税款所属期 ${start} ~ ${end}（共 ${months} 个月）的薪资基数，确认继续？`,
          "提示", {
            type: "warning"
          }
        ).then(() => {
          that.refreshSalaryBaseLoading = true;
          xz.ArdCurStat({
              StartTaxPeriod: start,
              EndTaxPeriod: end
            },
            "FillImportDetailSocialBase"
          ).then((res) => {
            that.refreshSalaryBaseLoading = false;
            if (res && res.status == "ok") {
              that.$message.success(res.msg || "刷新成功");
              that.refreshSalaryBaseDialogVisible = false;
              that.getSalaryBaseList();
            } else {
              that.$message.error((res && res.msg) || "刷新失败");
            }
          }).catch((err) => {
            that.refreshSalaryBaseLoading = false;
            that.$message.error((err && (err.msg || err.message)) || "刷新失败");
          });
        }).catch(() => {});
      },
      salaryBaseEdit(row) {
        this.salaryBaseRuleForm = {
          id: row.id,
          name: row.name,
          cardId: row.cardId,
          originalSalary: row.originalSalary,
          recognizedSalaryBase: row.recognizedSalaryBase,
          updateReason: row.updateReason,
        };
        this.salaryBaseDialogVisible = true;
      },
      submitSalaryBaseEdit() {
        if (!this.salaryBaseRuleForm.id) {
          this.$message.error("缺少主键 Id");
          return;
        }
        if (this.salaryBaseRuleForm.recognizedSalaryBase == null) {
          this.$message.warning("请填写认定薪资基数");
          return;
        }
        let that = this;
        that.salaryBaseBtnLoading = true;
        let data = Object.assign({}, that.salaryBaseRuleForm);
        xz.ArdCurStat(data, "UpdateSalaryBaseVerify").then((res) => {
          that.salaryBaseBtnLoading = false;
          if (res.status == "ok") {
            that.$message.success(res.msg || "保存成功");
            that.salaryBaseDialogVisible = false;
            that.getSalaryBaseList();
          } else {
            that.$message.error(res.msg || "保存失败");
          }
        });
      },
      handleUpload(file) {
        const formData = new FormData();
        formData.append("pagename", "empexcel");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.importUrl = res && res.Url ? res.Url : res;
          } else {
            this.importUrl = "";
          }
        });
      },
      handleRemove() {
        this.importUrl = "";
      },
      confirmImport() {
        if (!this.importUrl) {
          this.$message.warning("请先选择Excel文件");
          return;
        }
        this.isBtnLoading = true;
        let data = {
          Url: this.importUrl
        };
        xz.ArdCurStat(data, "ExporSocialSecurityBase").then((res) => {
          this.isBtnLoading = false;
          if (res.status == "ok") {
            this.$message.success(res.msg || "导入成功");
            this.showImport = false;
            this.getList();
          } else {
            this.$message.error(res.msg || "导入失败");
          }
        });
      },
      // 导出
      exporList() {
        let that = this;
        let data = Object.assign({}, that.listQuery);
        // 导出时写死一页 1 万条，确保全部数据导出
        data.PageModel.Page = 1;
        data.PageModel.Rows = 10000;
        xz.ArdCurStatExp(data, "EGetSocialSecurityBasePageList").then((res) => {
          try {
            var blob = new Blob([res]);
            var downloadUrl = window.URL.createObjectURL(blob);
            var anchor = document.createElement("a");
            anchor.href = downloadUrl;
            anchor.download = "社保基数列表.xlsx";
            anchor.click();
            window.URL.revokeObjectURL(downloadUrl);
          } catch (e) {
            that.$message.error("导出异常");
          }
        });
      },
      // ================= 驾驶舱 tab =================
      dashboardReset() {
        this.dashboardQuery = {
          year: String(new Date().getFullYear()),
          month: "",
          province: "",
          companyName: [],
          projectName: [],
          serviceDepart: [],
        };
        // 「按主体」「按服务部门」「按项目」趋势的独立主体/项目选择一并清空
        this.dashboardTrendCompanies = [];
        this.dashboardTrendDeptCompanies = [];
        this.dashboardTrendProjects = [];
        // 「按服务部门」tab：重置后公司主体下拉恢复为权限内全部主体
        if (this.dashboardTrendTab === "serviceDept") {
          this.dashboardDeptCompanyList = this.companyNameOptions();
        }
      },
      // ================= 驾驶舱数据加载 =================
      // 驾驶舱汇总卡片 + 排名看板
      loadDashboardData() {
        this.loadDashboardSummary();
        this.loadDashboardRank();
        // 趋势按当前 tab 路由：按主体→逐主体多曲线；按服务部门→多服务部门多曲线；按项目→多项目多曲线
        if (this.dashboardTrendTab === "project") {
          // 刷新前确保「按项目」tab 下拉数据已加载（xz.getProjectLists）
          if (!this.dashboardProjectList || this.dashboardProjectList.length === 0) {
            this.getProjectOptions();
          }
          this.getDashboardProjectTrend();
        } else if (this.dashboardTrendTab === "serviceDept") {
          this.getServiceDeptOptions();
          this.syncDeptCompanyOptions();
          this.getDashboardServiceDeptTrend();
        } else {
          this.getDashboardOverallTrend();
        }
      },
      // 驾驶舱汇总卡片（真实接口 GetDashboardSummary，口径与排名一致）
      //   主体/项目总数 = 有明细且有年度达标档案(ConsolidationRate)的对象；
      //   达标 = 实际夯实率 ≥ 达标要求；项目内任一主体桶未达标即项目未达标
      // 入参：年度/月份（同排名）、多公司主体、多项目、省市(InsuranceArea)
      loadDashboardSummary() {
        let that = this;
        const y = that.dashboardQuery.year || String(new Date().getFullYear());
        const param = {};
        if (that.dashboardQuery.month) {
          param.TaxPeriod = y + that.dashboardQuery.month; // 指定到具体月份（yyyyMM）
        } else {
          param.Year = y; // 按年整年统计
        }
        const compNames = that.dashboardQuery.companyName || [];
        if (compNames.length) {
          param.CompanyNames = compNames.slice();
        }
        const projNames = that.dashboardQuery.projectName || [];
        if (projNames.length) {
          param.ProjectNames = projNames.slice();
        }
        const depts = that.dashboardQuery.serviceDepart || [];
        if (depts.length) {
          param.ServiceDeparts = depts.slice();
        }
        const areaStr = (that.dashboardQuery.province || "").trim();
        if (areaStr) {
          param.InsuranceArea = areaStr;
        }
        xz.ArdCurStat(param, "GetDashboardSummary").then((res) => {
          if (res && res.status === "ok" && res.data) {
            const s = res.data;
            // 后端比率为百分数（77.8 表示 77.8%）；null = 无对象，显示 "--"
            const fmtRate = (v) => {
              if (v === null || v === undefined || v === "") return "--";
              const n = Number(v);
              return Number.isInteger(n) ? n + "%" : n.toFixed(1) + "%";
            };
            that.dashboardSummary = {
              companyTotal: s.companyTotal || 0,
              qualifiedCompany: s.qualifiedCompany || 0,
              unQualifiedCompany: s.unQualifiedCompany || 0,
              companyQualifiedRate: fmtRate(s.companyQualifiedRate),
              companyUnQualifiedRate: fmtRate(s.companyUnQualifiedRate),
              serviceDeptTotal: s.serviceDeptTotal || 0,
              qualifiedServiceDept: s.qualifiedServiceDept || 0,
              unQualifiedServiceDept: s.unQualifiedServiceDept || 0,
              serviceDeptQualifiedRate: fmtRate(s.serviceDeptQualifiedRate),
              serviceDeptUnQualifiedRate: fmtRate(s.serviceDeptUnQualifiedRate),
              projectTotal: s.projectTotal || 0,
              qualifiedProject: s.qualifiedProject || 0,
              unQualifiedProject: s.unQualifiedProject || 0,
              projectQualifiedRate: fmtRate(s.projectQualifiedRate),
              projectUnQualifiedRate: fmtRate(s.projectUnQualifiedRate),
            };
          } else {
            that.$message.error((res && res.msg) || "获取汇总统计失败");
          }
        }).catch((err) => {
          that.$message.error((err && (err.msg || err.message)) || "获取汇总统计失败");
        });
      },
      // 排名看板 - 数据加载
      //   主体排名 → GetCompanyRankDiffRate；服务部门排名 → GetServiceDeptRankDiffRate；项目排名 → GetProjectRankDiffRate
      //   （DiffStatus 区分达标状态、SortType 区分率/金额两种排序，四个子 tab 全部走真实接口）
      loadDashboardRank() {
        const subOk = ["unQualified", "diff", "qualified", "qualifiedRate"].indexOf(this.dashboardRankSub) > -1;
        if (this.dashboardRankActive === "company" && subOk) {
          this.getCompanyRankDiffRate();
        } else if (this.dashboardRankActive === "serviceDept" && subOk) {
          this.getServiceDeptRankDiffRate();
        } else if (this.dashboardRankActive === "project" && subOk) {
          this.getProjectRankDiffRate();
        } else {
          this.setDemoRankTable();
        }
      },
      // 排名看板 外层 tab（主体排名/服务部门排名/项目排名）切换
      dashboardRankTabClick(tab) {
        const name = typeof tab === "string" ? tab : (tab && tab.name);
        if (name) this.dashboardRankActive = name;
        this.loadDashboardRank();
      },
      // 排名看板 内层子 tab（差异率/差异金额/已达标…）切换
      dashboardRankSubTabClick(tab) {
        const name = typeof tab === "string" ? tab : (tab && tab.name);
        if (name) this.dashboardRankSub = name;
        this.loadDashboardRank();
      },
      // 排名看板 - 主体排名 Top10（真实接口）
      // 口径：主体夯实率 = Σ社保基数/Σ薪资基数；差异金额 = Σ(社保基数-薪资基数×达标要求夯实率)；
      //       达标要求 = 该主体对应年度档案 ConsolidationRate；
      //   子 tab → 入参映射：
      //     unQualified   未达标差异率 Top10   → DiffStatus=UnQualified(默认) + SortType=Rate(默认)
      //     diff          未达标差异金额 Top10  → DiffStatus=UnQualified(默认) + SortType=Amount
      //     qualified     已达标差异率 Top10    → DiffStatus=Qualified      + SortType=Rate(默认)
      //     qualifiedRate 已达标差异金额 Top10  → DiffStatus=Qualified      + SortType=Amount
      // 入参：顶部年度 dashboardQuery.year + 月份 dashboardQuery.month（选了月则按单月，否则按整年）
      getCompanyRankDiffRate() {
        let that = this;
        that.dashboardRankLoading = true;
        const y = that.dashboardQuery.year || String(new Date().getFullYear());
        const param = {};
        if (that.dashboardQuery.month) {
          param.TaxPeriod = y + that.dashboardQuery.month; // 指定到具体月份（yyyyMM）
        } else {
          param.Year = y; // 按年整年统计
        }
        if (that.dashboardRankSub === "qualified" || that.dashboardRankSub === "qualifiedRate") {
          param.DiffStatus = "Qualified"; // 已达标（实际夯实率 ≥ 达标要求）
        }
        if (that.dashboardRankSub === "diff" || that.dashboardRankSub === "qualifiedRate") {
          param.SortType = "Amount"; // 按差异金额排序（未达标按缺口金额/已达标按超额金额）
        }
        // 入参支持多主体名/多项目名：顶部公司主体/项目均支持多选，原样传数组（空数组不传 = 全部）
        const compNames = that.dashboardQuery.companyName || [];
        if (compNames.length) {
          param.CompanyNames = compNames.slice();
        }
        const projNames = that.dashboardQuery.projectName || [];
        if (projNames.length) {
          param.ProjectNames = projNames.slice();
        }
        // 省市条件：档案表 JB_busi_SocialSecurityBase.InsuranceArea 存储"省,市"（如 安徽,黄山市），支持省/市/省,市
        const areaStr = (that.dashboardQuery.province || "").trim();
        if (areaStr) {
          param.InsuranceArea = areaStr;
        }
        xz.ArdCurStat(param, "GetCompanyRankDiffRate").then((res) => {
          that.dashboardRankLoading = false;
          if (res && res.status === "ok" && res.data) {
            const output = res.data; // { periodName, data:[...] }
            that.dashboardRankPeriod = (output && output.periodName) || that.getRankPeriodText();
            const rows = (output && output.data) || [];
            that.dashboardRankTable = rows.map((it) => ({
              name: it.companyName || "-",
              salaryAvg: it.salaryAvg || "-",
              socialSecurityAvg: it.socialSecurityAvg || "-",
              socialSecurityCount: it.socialSecurityCount || "-",
              socialTotal: it.socialSecurityTotal,
              salaryTotal: it.salaryTotal,
              rate: it.actualRate,
              require: it.requireRate,
              diffRate: it.diffRate,
              diffAmount: it.diffAmount,
              qualified: it.qualified || (Number(it.diffRate) >= 0 ? "达标" : "未达标"),
            }));
          } else {
            that.$message.error((res && res.msg) || "获取未达标差异率排名失败");
          }
        }).catch((err) => {
          that.dashboardRankLoading = false;
          that.$message.error((err && (err.msg || err.message)) || "获取未达标差异率排名失败");
        });
      },
      // 排名看板 - 项目排名 Top10（真实接口）
      // 口径：桶 = 项目×公司主体；桶夯实率 = Σ社保基数/Σ薪资基数；达标要求 = 该主体对应年度档案 ConsolidationRate；
      //       项目内任一主体桶未达标 → 项目未达标（全部达标才达标）；
      //       项目差异率 = Min(各桶差异率)；项目差异金额 = 未达标项目 Σ(未达标桶缺口金额，达标桶不计入) / 已达标项目各桶超额合计；
      //   子 tab → 入参映射同主体排名（DiffStatus 达标状态、SortType 排序维度）
      // 入参：顶部年度 dashboardQuery.year + 月份 dashboardQuery.month（选了月则按单月，否则按整年）
      getProjectRankDiffRate() {
        let that = this;
        that.dashboardRankLoading = true;
        const y = that.dashboardQuery.year || String(new Date().getFullYear());
        const param = {};
        if (that.dashboardQuery.month) {
          param.TaxPeriod = y + that.dashboardQuery.month; // 指定到具体月份（yyyyMM）
        } else {
          param.Year = y; // 按年整年统计
        }
        if (that.dashboardRankSub === "qualified" || that.dashboardRankSub === "qualifiedRate") {
          param.DiffStatus = "Qualified"; // 已达标（项目内全部主体桶达标）
        }
        if (that.dashboardRankSub === "diff" || that.dashboardRankSub === "qualifiedRate") {
          param.SortType = "Amount"; // 按项目差异金额排序
        }
        // 入参支持多主体名/多项目名：顶部公司主体/项目均支持多选，原样传数组（空数组不传 = 全部）
        const compNames = that.dashboardQuery.companyName || [];
        if (compNames.length) {
          param.CompanyNames = compNames.slice();
        }
        const projNames = that.dashboardQuery.projectName || [];
        if (projNames.length) {
          param.ProjectNames = projNames.slice();
        }
        // 省市条件：档案表 JB_busi_SocialSecurityBase.InsuranceArea 存储"省,市"（如 安徽,黄山市），支持省/市/省,市
        const areaStr = (that.dashboardQuery.province || "").trim();
        if (areaStr) {
          param.InsuranceArea = areaStr;
        }
        xz.ArdCurStat(param, "GetProjectRankDiffRate").then((res) => {
          that.dashboardRankLoading = false;
          if (res && res.status === "ok" && res.data) {
            const output = res.data; // { periodName, data:[...] }
            that.dashboardRankPeriod = (output && output.periodName) || that.getRankPeriodText();
            const rows = (output && output.data) || [];
            that.dashboardRankTable = rows.map((it) => ({
              name: it.projectName || "-",
              socialSecurityCount: it.socialSecurityCount,
              salaryAvg: it.salaryAvg,
              socialSecurityAvg: it.socialSecurityAvg,
              socialTotal: it.socialSecurityTotal,
              salaryTotal: it.salaryTotal,
              rate: it.actualRate,
              require: null, // 项目排名不展示达标要求列
              diffRate: it.diffRate,
              diffAmount: it.diffAmount,
              qualified: it.qualified || (Number(it.diffRate) >= 0 ? "达标" : "未达标"),
            }));
          } else {
            that.$message.error((res && res.msg) || "获取项目排名失败");
          }
        }).catch((err) => {
          that.dashboardRankLoading = false;
          that.$message.error((err && (err.msg || err.message)) || "获取项目排名失败");
        });
      },
      // 排名看板 - 服务部门排名 Top10（真实接口）
      // 口径：桶=服务部门×主体，桶实际夯实率=Σ社保基数/Σ薪资基数；达标要求=该主体对应年度档案 ConsolidationRate；
      //       服务部门内任一主体桶未达标 → 服务部门未达标（全部达标才达标）；
      //       服务部门差异率 = Min(各主体桶差异率)；
      //       服务部门差异金额 = 未达标时 Σ(未达标主体桶缺口，达标桶不计入) / 已达标时各桶超额合计；
      //   子 tab → 入参映射同项目排名（DiffStatus / SortType）
      getServiceDeptRankDiffRate() {
        let that = this;
        that.dashboardRankLoading = true;
        const y = that.dashboardQuery.year || String(new Date().getFullYear());
        const param = {};
        if (that.dashboardQuery.month) {
          param.TaxPeriod = y + that.dashboardQuery.month; // 指定到具体月份（yyyyMM）
        } else {
          param.Year = y; // 按年整年统计
        }
        if (that.dashboardRankSub === "qualified" || that.dashboardRankSub === "qualifiedRate") {
          param.DiffStatus = "Qualified"; // 已达标（服务部门内全部主体桶达标）
        }
        if (that.dashboardRankSub === "diff" || that.dashboardRankSub === "qualifiedRate") {
          param.SortType = "Amount"; // 按服务部门差异金额排序
        }
        // 入参支持多主体名/多项目名：顶部公司主体/项目均支持多选，原样传数组（空数组不传 = 全部）
        const compNames = that.dashboardQuery.companyName || [];
        if (compNames.length) {
          param.CompanyNames = compNames.slice();
        }
        const projNames = that.dashboardQuery.projectName || [];
        if (projNames.length) {
          param.ProjectNames = projNames.slice();
        }
        const areaStr = (that.dashboardQuery.province || "").trim();
        if (areaStr) {
          param.InsuranceArea = areaStr;
        }
        xz.ArdCurStat(param, "GetServiceDeptRankDiffRate").then((res) => {
          that.dashboardRankLoading = false;
          if (res && res.status === "ok" && res.data) {
            const output = res.data; // { periodName, data:[...] }
            that.dashboardRankPeriod = (output && output.periodName) || that.getRankPeriodText();
            const rows = (output && output.data) || [];
            that.dashboardRankTable = rows.map((it) => ({
              name: it.serviceDepart || "-",
              socialSecurityCount: it.socialSecurityCount,
              salaryAvg: it.salaryAvg,
              socialSecurityAvg: it.socialSecurityAvg,
              socialTotal: it.socialSecurityTotal,
              salaryTotal: it.salaryTotal,
              rate: it.actualRate,
              require: null, // 服务部门排名不展示达标要求列
              diffAmount: it.diffAmount,
              diffRate: it.diffRate,
              qualified: it.qualified || (Number(it.diffRate) >= 0 ? "达标" : "未达标"),
            }));
          } else {
            that.$message.error((res && res.msg) || "获取服务部门排名失败");
          }
        }).catch((err) => {
          that.dashboardRankLoading = false;
          that.$message.error((err && (err.msg || err.message)) || "获取服务部门排名失败");
        });
      },
      // 排名看板统计期间兜底文案（后端未返回 periodName 时本地拼）
      getRankPeriodText() {
        const y = this.dashboardQuery.year || String(new Date().getFullYear());
        return this.dashboardQuery.month ? `${y}年${this.dashboardQuery.month}月` : `${y}年`;
      },
      // 排名看板 期次展示文案（附注当前子 tab 的排序维度，主体/项目排名均适用）
      rankPeriodText() {
        const tipMap = {
          unQualified: "按缺口率",
          diff: "按缺口金额",
          qualified: "按超额率",
          qualifiedRate: "按超额金额"
        };
        const tip = tipMap[this.dashboardRankSub] || "";
        return "统计期间：" + this.dashboardRankPeriod + (tip ? "（" + tip + "）" : "");
      },
      dashboardTrendTabClick(tab) {
        const name = typeof tab === "string" ? tab : (tab && tab.name);
        if (name) this.dashboardTrendTab = name;
        // 按主体/按服务部门/按项目 → 均可多选多曲线
        if (this.dashboardTrendTab === "project") {
          // 进入「按项目」tab 时只确保下拉数据已绑定；有已选项目才请求趋势，未选择则仅展示空态（不逐项发起请求）
          if (!this.dashboardProjectList || this.dashboardProjectList.length === 0) {
            this.getProjectOptions();
          }
          this.getDashboardProjectTrend();
        } else if (this.dashboardTrendTab === "serviceDept") {
          // 进入「按服务部门」tab 时，先确保下拉数据已加载，再请求趋势
          this.getServiceDeptOptions();
          this.syncDeptCompanyOptions();
          this.getDashboardServiceDeptTrend();
        } else {
          // 按主体：仅按已选主体绘制曲线（未选主体时仅"总体"一条曲线），不再逐主体逐次请求
          this.getDashboardOverallTrend();
        }
      },
      // 「按主体」tab 的选择主体变化：只按 dashboardTrendCompanies 重绘趋势曲线，
      //   不回写顶部"公司主体"下拉(dashboardQuery.companyName)，也不触发汇总卡/排名看板的全局主体过滤
      onTrendCompanyChange() {
        this.getDashboardOverallTrend();
      },
      // 「按服务部门」tab 的公司主体选择变化：只按 dashboardTrendDeptCompanies 重绘该 tab 的趋势曲线，
      //   不回写顶部"公司主体"下拉(dashboardQuery.companyName)，也不触发汇总卡/排名看板的全局主体过滤
      onTrendDeptCompanyChange() {
        this.getDashboardServiceDeptTrend();
      },
      // 「按项目」tab 的选择项目变化：实时重绘该 tab 的趋势曲线（有选中 → 一次请求带全部选中项目；
      //   清空选择 → 不发请求并展示空态），不回写顶部"项目"下拉(dashboardQuery.projectName)，也不触发汇总卡/排名看板的全局过滤
      onTrendProjectChange() {
        this.getDashboardProjectTrend();
      },
      // 夯实率趋势 - 按主体（真实接口）：
      //   每个主体当月夯实率 = 当月该主体社保基数之和 / 当月该主体薪资基数之和（主体取"选择主体"多选下拉 dashboardTrendCompanies，每个主体 1 条曲线）
      //   总体曲线始终附带（CompanyNames 传空 → 后端按数据权限汇总当月全部社保/薪资基数）
      //   一次请求携带全部选中主体（CompanyNames），后端一次返回"总体 + 各主体"多条曲线，绝不逐主体逐次请求；
      //   未选择主体时只传空 → 仅画"总体"一条曲线。
      getDashboardOverallTrend() {
        let that = this;
        const seq = ++that.dashboardTrendReqSeq; // 先自增：作废其它 tab 在途的旧响应
        const range = Number(that.dashboardTrendRange || 12);
        // 「按主体」tab：主体取独立选择的 dashboardTrendCompanies，与顶部"公司主体"下拉互不影响
        const comps = (that.dashboardTrendCompanies || []).slice();
        const param = {
          EndTaxPeriod: null,
          MonthCount: range,
        };
        if (comps.length) param.CompanyNames = comps;
        xz.ArdCurStat(param, "GetDashboardOverallTrend").then((res) => {
          if (seq !== that.dashboardTrendReqSeq) return; // 期间已切 tab 或选择再次变化，丢弃本次过期结果
          if (res && res.status === "ok" && res.data) {
            const list = [];
            // 总体曲线（始终排在首位）
            if (res.data.data && res.data.data.length) {
              const s = that.toDashboardSeries("总体", res.data.data);
              if (s && s.name) list.push(s);
            }
            // 各主体曲线（CompanyData，按传入主体顺序）
            (res.data.companyData || []).forEach((item) => {
              const s = that.toDashboardSeries((item && item.companyName) || "", (item && item.data) || []);
              if (s && s.name) list.push(s);
            });
            // list 为空时由 drawDashboardChart 绘制空态提示
            that.dashboardTrendSeries = list;
            // 区间内未达标主体（后端按各主体自身 ConsolidationRate 判定；未选主体时统计权限内全部主体）
            that.dashboardUnQualifiedCompanies = res.data.unQualifiedCompanies || [];
            that.$nextTick(() => that.drawDashboardChart());
          } else {
            that.$message.error((res && res.msg) || "获取夯实率趋势失败");
          }
        }).catch((err) => {
          if (seq !== that.dashboardTrendReqSeq) return; // 丢弃过期请求的错误提示
          that.$message.error((err && (err.msg || err.message)) || "获取夯实率趋势失败");
        });
      },
      // 夯实率趋势 - 按项目多选多曲线（真实接口）：
      //   每个项目当月夯实率 = 当月该项目社保基数之和 / 当月该项目薪资基数之和；多选项目则绘制多条曲线；
      //   项目取「按项目」tab 独立选择的 dashboardTrendProjects，与顶部"项目"下拉(dashboardQuery.projectName)无关
      //   实时化说明：
      //     · 仅当选择项目发生变动（onTrendProjectChange / 进入 tab 刷新）且已选中项目时才发起请求；
      //       一次请求携带全部选中项目（ProjectNames），后端一次返回多项目曲线，绝不遍历下拉选项逐项请求。
      //     · 未选择项目（含下拉数据加载/绑定期）→ 不发起任何请求，仅清空曲线并展示图表空态提示。
      getDashboardProjectTrend() {
        let that = this;
        const seq = ++that.dashboardTrendReqSeq; // 先自增：即使本次不发请求，也要作废其它 tab 在途的旧响应
        that.dashboardUnQualifiedCompanies = []; // 未达标主体清单只在「按主体」tab 展示
        const projects = (that.dashboardTrendProjects || []).slice();
        if (!projects.length) {
          // 未选择任何项目：不发请求，仅清空并显示空态（图内已有"请先选择项目"提示）
          that.dashboardTrendSeries = [];
          that.$nextTick(() => that.drawDashboardChart());
          return;
        }
        const range = Number(that.dashboardTrendRange || 12);
        xz.ArdCurStat({
          EndTaxPeriod: null,
          MonthCount: range,
          ProjectNames: projects,
        }, "GetDashboardProjectTrend").then((res) => {
          if (seq !== that.dashboardTrendReqSeq) return; // 期间已切 tab 或选择再次变化，丢弃本次过期结果
          if (res && res.status === "ok" && res.data && res.data.data) {
            const seriesList = (res.data.data || [])
              .map((s) => that.toDashboardSeries(s.projectName || "", s.data || []))
              .filter((s) => s.name);
            that.dashboardTrendSeries = seriesList;
            that.$nextTick(() => that.drawDashboardChart());
          } else {
            that.$message.error((res && res.msg) || "获取按项目夯实率趋势失败");
          }
        }).catch((err) => {
          if (seq !== that.dashboardTrendReqSeq) return; // 丢弃过期请求的错误提示
          that.$message.error((err && (err.msg || err.message)) || "获取按项目夯实率趋势失败");
        });
      },
      // 夯实率趋势 - 按服务部门多选多曲线（真实接口）：
      // 每个服务部门当月夯实率 = 当月该服务部门社保基数之和 / 当月该服务部门薪资基数之和；
      //   可按主体多选过滤，主体来源为「按服务部门」tab 独立选择的 dashboardTrendDeptCompanies（与顶部公司主体下拉无关）
      getDashboardServiceDeptTrend() {
        let that = this;
        const seq = ++that.dashboardTrendReqSeq; // 先自增：即使本次不发请求，也要作废其它 tab 在途的旧响应
        that.dashboardUnQualifiedCompanies = []; // 未达标主体清单只在「按主体」tab 展示
        const depts = that.dashboardQuery.serviceDepart || [];
        if (!depts.length) {
          // 未选择任何服务部门：不发请求，清空上一 tab 的曲线并切换到本 tab 的图表空态（与「按项目」tab 行为一致，不弹提示）
          that.dashboardTrendSeries = [];
          that.$nextTick(() => that.drawDashboardChart());
          return;
        }
        const comps = (that.dashboardTrendDeptCompanies || []).slice();
        const range = Number(that.dashboardTrendRange || 12);
        xz.ArdCurStat({
          EndTaxPeriod: null,
          MonthCount: range,
          ServiceDeparts: depts,
          CompanyNames: comps,
        }, "GetDashboardServiceDeptTrend").then((res) => {
          if (seq !== that.dashboardTrendReqSeq) return; // 期间已切 tab 或选择再次变化，丢弃本次过期结果
          if (res && res.status === "ok" && res.data && res.data.data) {
            const seriesList = (res.data.data || [])
              .map((s) => that.toDashboardSeries(s.serviceDepart || "", s.data || []))
              .filter((s) => s.name);
            that.dashboardTrendSeries = seriesList;
            that.$nextTick(() => that.drawDashboardChart());
          } else {
            that.$message.error((res && res.msg) || "获取按服务部门夯实率趋势失败");
          }
        }).catch((err) => {
          if (seq !== that.dashboardTrendReqSeq) return; // 丢弃过期请求的错误提示
          that.$message.error((err && (err.msg || err.message)) || "获取按服务部门夯实率趋势失败");
        });
      },
      // 服务部门下拉数据源（接口：GetServiceDepartList；首次进入 serviceDept tab 时拉取）
      //   主体过滤用「按服务部门」tab 独立选择的 dashboardTrendDeptCompanies（与顶部公司主体下拉无关）
      getServiceDeptOptions() {
        let that = this;
        if (that.dashboardServiceDeptList && that.dashboardServiceDeptList.length) return;
        const comps = (that.dashboardTrendDeptCompanies || []).slice();
        xz.ArdCurStat({
          CompanyNames: comps
        }, "GetServiceDepartList").then((res) => {
          if (res && res.status === "ok" && res.data && res.data.data) {
            that.dashboardServiceDeptList = res.data.data || [];
          } else {
            that.dashboardServiceDeptList = [];
          }
        }).catch(() => {
          that.dashboardServiceDeptList = [];
        });
      },
      // 「按服务部门」tab 公司主体下拉默认数据：当前用户数据权限内的全部主体名
      companyNameOptions() {
        return (this.dashboardCompanyList || [])
          .map((c) => c && c.name)
          .filter((n) => n && String(n).trim());
      },
      // 同步「按服务部门」tab 的公司主体下拉：未选择服务部门且下拉未初始化时，填充权限内全部主体
      syncDeptCompanyOptions() {
        const depts = (this.dashboardQuery.serviceDepart || []).slice();
        if (!depts.length && !(this.dashboardDeptCompanyList && this.dashboardDeptCompanyList.length)) {
          this.dashboardDeptCompanyList = this.companyNameOptions();
        }
      },
      // 服务部门选择变化：加载对应部门下、当前用户权限可取到的公司主体并绑定下拉，随后刷新趋势
      onServiceDepartChange() {
        let that = this;
        const depts = (that.dashboardQuery.serviceDepart || []).slice();
        const refresh = () => that.loadDashboardData();
        if (!depts.length) {
          // 清空服务部门 → 公司主体下拉恢复为权限内全部主体
          that.dashboardDeptCompanyList = that.companyNameOptions();
          refresh();
          return;
        }
        xz.ArdCurStat({
          ServiceDeparts: depts
        }, "GetCompanyListByServiceDepart").then((res) => {
          if (res && res.status === "ok" && res.data && res.data.data) {
            const opts = (res.data.data || [])
              .map((n) => String(n).trim())
              .filter(Boolean);
            that.dashboardDeptCompanyList = opts;
            // 保留仍属于该部门下主体的独立已选值（dashboardTrendDeptCompanies），其余移除后继续刷新；不影响顶部公司主体下拉
            const before = that.dashboardTrendDeptCompanies || [];
            const keep = before.filter((n) => opts.indexOf(n) >= 0);
            if (keep.length !== before.length) {
              that.dashboardTrendDeptCompanies = keep;
            }
          }
          refresh();
        }).catch(() => refresh());
      },
      // 把后端月度列表转成绘图序列 { name, months, rates }
      toDashboardSeries(name, list) {
        const arr = list || [];
        const months = arr.map((it) => {
          const p = (it.taxPeriod || "").replace("-", "");
          return p.length === 6 ? p.substring(0, 4) + "-" + p.substring(4) : (it.taxPeriod || "");
        });
        const rates = arr.map((it) => {
          if (it.rate === null || it.rate === undefined || it.rate === "") return null;
          return Number(it.rate);
        });
        // 每月达标判定（后端按「实际夯实率 ≥ 达标要求」给出：达标/未达标/null）
        const qualifieds = arr.map((it) => it.qualified || null);
        // 每月达标要求（各主体 = JB_busi_SocialSecurityBase.ConsolidationRate；总体 = 按薪资基数加权的折算值）
        const requireRates = arr.map((it) => {
          if (it.requireRate === null || it.requireRate === undefined || it.requireRate === "") return null;
          return Number(it.requireRate);
        });
        return {
          name,
          months,
          rates,
          qualifieds,
          requireRates
        };
      },
      // 未接后端子 tab 的排名演示占位（与表格列结构一致）
      setDemoRankTable() {
        this.dashboardRankPeriod = this.getRankPeriodText();
        this.dashboardRankTable = this.buildDemoRank();
      },
      buildDemoRank() {
        const names = [
          "上海分公司", "北京分公司", "苏州分公司", "南京分公司", "杭州分公司",
          "深圳分公司", "广州分公司", "成都分公司", "武汉分公司", "西安分公司"
        ];
        const rates = [92.5, 91.8, 90.4, 89.6, 88.9, 88.1, 87.4, 86.8, 86.0, 85.3];
        return names.map((n, i) => {
          const salaryTotal = 17500000 - i * 1050000;
          return {
            name: n,
            socialTotal: 16000000 - i * 1100000,
            salaryTotal,
            rate: rates[i],
            require: 95,
            diffRate: parseFloat((rates[i] - 95).toFixed(2)),
            diffAmount: Math.round((rates[i] / 100 - 0.95) * salaryTotal),
            qualified: "未达标",
          };
        });
      },
      // 夯实率趋势图（通用多序列渲染）：
      //   按主体 = 每个主体 1 条曲线；按服务部门/项目多选 = 每项 1 条曲线
      //   100% 达标要求参考线 + 单曲线红圈"未达标月份"仅「按主体」tab 展示
      //   （按服务部门/按项目内各主体达标要求不一，展示单条 100% 参考线会误导，故不展示）
      drawDashboardChart() {
        if (!this.$refs.dashChart) return;
        if (this.dashboardChart) {
          this.dashboardChart.dispose();
          this.dashboardChart = null;
        }
        const chart = echarts.init(this.$refs.dashChart);
        const seriesArr = this.dashboardTrendSeries || [];
        if (!seriesArr.length) {
          // 空态：未选择任何主体/服务部门/项目时给出居中提示
          const emptyText = this.dashboardTrendTab === "serviceDept" ?
            "请先选择服务部门（可多选），再查看「按服务部门」的夯实率趋势" :
            this.dashboardTrendTab === "project" ?
            "请先选择项目（可多选），再查看「按项目」的夯实率趋势" :
            "请先选择主体（可多选），再查看「按主体」的夯实率趋势";
          chart.setOption({
            title: {
              text: emptyText,
              left: "center",
              top: "middle",
              textStyle: {
                color: "#909399",
                fontSize: 14,
                fontWeight: "normal"
              }
            }
          });
          this.dashboardChart = chart;
          return;
        }
        // 统一横轴为第一序列的月份（各序列同区间同月序）
        const months = (seriesArr[0].months || []);
        const colorPalette = ["#1890ff", "#52c41a", "#fa8c16", "#722ed1", "#13c2c2", "#eb2f96", "#faad14", "#2f54eb", "#f5222d", "#a0d911"];
        const single = seriesArr.length === 1;
        const series = [];
        const legendData = [];
        // 收集「未达标月份」的点：仅后端判定为"未达标"的月份才落点，达标月份不出现
        const unQualifiedPoints = [];
        seriesArr.forEach((s, idx) => {
          if (!s || !s.rates) return;
          const name = s.name || ("序列" + (idx + 1));
          const color = colorPalette[idx % colorPalette.length];
          legendData.push(name);
          series.push({
            name,
            type: "line",
            data: s.rates,
            smooth: false, // 折线展示（不平滑）
            connectNulls: true,
            lineStyle: {
              color,
              width: single ? 3 : 2.5
            },
            itemStyle: {
              color
            },
            symbol: "circle",
            symbolSize: single ? 8 : 6,
            // 每个月份节点显示具体数据
            label: {
              show: true,
              position: "top",
              fontSize: single ? 11 : 10,
              color: "#333",
              formatter: (p) => {
                let v = p.value;
                if (Array.isArray(v)) v = v[1];
                if (v === null || v === undefined || isNaN(v)) return "";
                return v + "%";
              }
            },
            tooltip: {
              show: true
            }
          });
          // 未达标月份：仅按各公司主体自身的达标要求(ConsolidationRate)判定，"总体"曲线不参与标记
          if (name === "总体") return;
          (s.qualifieds || []).forEach((q, i) => {
            if (q !== "未达标") return;
            const v = (s.rates || [])[i];
            if (v === null || v === undefined || isNaN(Number(v))) return;
            if (!months[i]) return;
            unQualifiedPoints.push([months[i], Number(v)]);
          });
        });
        // 「未达标月份」标记：仅「按主体」tab 展示（按服务部门/按项目内各主体达标要求不一，不做整体标记）
        const showUnQualified = this.dashboardTrendTab === "company";
        // if (showRequireLine) {
        //   legendData.push("达标要求");
        //   series.push({
        //     name: "达标要求",
        //     type: "line",
        //     data: months.map(() => 100),
        //     lineStyle: {
        //       color: "#ff7a45",
        //       type: "dashed",
        //       width: 2
        //     },
        //     symbol: "none",
        //     tooltip: {
        //       show: false
        //     }
        //   });
        // }
        if (showUnQualified && unQualifiedPoints.length) {
          legendData.push("未达标月份");
          series.push({
            name: "未达标月份",
            type: "scatter",
            data: unQualifiedPoints,
            symbol: "circle",
            symbolSize: single ? 18 : 14,
            // 红色空心圈：透明填充 + 红色描边，只圈住未达标的月份点
            itemStyle: {
              color: "rgba(255,77,79,0)",
              borderColor: "#ff4d4f",
              borderWidth: 2
            },
            zlevel: 2,
            tooltip: {
              show: false
            }
          });
        }
        chart.setOption({
          tooltip: {
            trigger: "axis",
            formatter: (params) => {
              const axisVal = (params && params.length && params[0].axisValue) || "";
              let html = `<b>${axisVal}</b>`;
              (params || []).forEach((p) => {
                if (p.seriesName === "达标要求" || p.seriesName === "未达标月份") return;
                let v = p.value;
                if (Array.isArray(v)) v = v[1];
                if (v === null || v === undefined || isNaN(v)) return;
                // 未达标月份在提示里同步标红（与图上的红空心圈一一对应）
                const seq = (this.dashboardTrendSeries || []).find((x) => x.name === p.seriesName);
                const mi = seq && seq.months ? seq.months.indexOf(p.axisValue) : -1;
                const unQualified = mi >= 0 && (seq.qualifieds || [])[mi] === "未达标";
                const reqRate = mi >= 0 && seq ? (seq.requireRates || [])[mi] : null;
                html += `<br/>${p.seriesName}：<b>${v}%</b>` +
                  (reqRate !== null && reqRate !== undefined && !isNaN(reqRate) ?
                    `<span style="color:#999;margin-left:4px">要求 ${reqRate}%</span>` : "") +
                  (unQualified ? `<span style="color:#ff4d4f;margin-left:4px">未达标</span>` : "");
              });
              return html;
            }
          },
          legend: {
            data: legendData,
            bottom: 0,
            // 「未达标月份」：选中（高亮）时显示未达标点的红色空心圈，取消选中即隐藏；达标月份不落点
            selected: showUnQualified ? {
              "未达标月份": !!this.dashboardShowUnQualified
            } : {}
          },
          grid: {
            left: 60,
            right: 30,
            top: 30,
            bottom: 50
          },
          xAxis: {
            type: "category",
            data: months,
            boundaryGap: false
          },
          yAxis: {
            type: "value",
            min: (v) => Math.max(0, Math.floor((v.min === Infinity ? 0 : v.min) - 2)),
            max: (v) => Math.ceil((v.max === -Infinity ? 100 : v.max) + 2),
            axisLabel: {
              formatter: "{value}%"
            }
          },
          series
        });
        // 图例切换：记住用户对「未达标月份」的选择，重绘（切换主体/区间/tab）后保持一致
        chart.on("legendselectchanged", (params) => {
          if (!params || !params.selected) return;
          if (Object.prototype.hasOwnProperty.call(params.selected, "未达标月份")) {
            this.dashboardShowUnQualified = !!params.selected["未达标月份"];
          }
        });
        this.dashboardChart = chart;
        window.addEventListener("resize", () => this.dashboardChart && this.dashboardChart.resize());
      },
    },
    watch: {
      outerTab(n) {
        if (n === "dashboard") {
          this.$nextTick(() => this.loadDashboardData());
        } else if (this.dashboardChart) {
          this.dashboardChart.dispose();
          this.dashboardChart = null;
        }
      }
    }
  };
</script>

<style scoped>
  .page_basicData {
    background: #f5f7fa;
    min-height: 100%;
    padding: 10px;
  }

  /* ================= 驾驶舱 ================= */
  .page_dashboard {
    padding: 4px 0 10px 0;
  }

  .page_dashboard .dash-cards {
    display: grid;
    grid-template-columns: repeat(9, 1fr);
    gap: 6px;
    margin: 10px 0;
    flex-shrink: 0;
  }

  .page_dashboard .dash-card {
    background: #fff;
    border-radius: 6px;
    padding: 8px 6px;
    text-align: center;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
    border: 1px solid #e8e8e8;
    cursor: pointer;
    transition: all 0.2s;
    position: relative;
  }

  .page_dashboard .dash-card:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
    border-color: #c0c0c0;
    border-bottom: 2px solid #1890ff;
  }

  .page_dashboard .dash-card .title {
    font-size: 12px;
    color: #666;
    margin-bottom: 2px;
    font-weight: 600;
    letter-spacing: 0.2px;
    white-space: nowrap;
  }

  .page_dashboard .dash-card .num {
    font-family: 'SF Mono', 'Cascadia Code', 'Roboto Mono', 'Consolas', monospace;
    font-size: 18px;
    font-weight: 700;
    color: #333;
    line-height: 1.1;
  }

  .page_dashboard .dash-card .unit {
    font-size: 10px;
    color: #666;
    margin-top: 1px;
    white-space: nowrap;
  }


  @media (max-width: 1366px) {
    .page_dashboard .dash-card .num {
      font-size: 16px;
    }

    .page_dashboard .dash-card .title {
      font-size: 9px;
    }
  }

  @media (max-width: 1280px) {
    .page_dashboard .dash-cards {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  .page_dashboard .dash-block {
    background: #fff;
    border-radius: 6px;
    padding: 10px 14px 14px 14px;
    margin-bottom: 10px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  }

  .page_dashboard .dash-block-header {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 8px;
  }

  .page_dashboard .dash-block-header .title {
    font-size: 15px;
    font-weight: 600;
    color: #333;
    margin-right: 20px;
  }

  .page_dashboard .dash-block-header .stat-period {
    font-size: 12px;
    color: #999;
    margin-left: auto;
  }

  .page_dashboard .dash-inline-tabs>>>.el-tabs__header {
    margin-bottom: 0;
  }

  .page_dashboard .dash-inline-tabs>>>.el-tabs__nav-wrap::after {
    height: 1px;
  }

  /* 夯实率趋势头部：标题居左、统计区间(近12个月)居右；tab 另起一行，故去掉头部与 tab 线重复的分隔线 */
  .page_dashboard .dash-trend-header {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 2px;
  }

  .page_dashboard .dash-trend-range {
    margin-left: auto;
  }

  .page_dashboard .dash-trend-tabs>>>.el-tabs__header {
    margin: 0 0 4px 0;
  }

  .page_dashboard .dash-trend-tabs>>>.el-tabs__nav-wrap::after {
    height: 1px;
  }

  .page_dashboard .dash-rank-tabs>>>.el-tabs__content {
    overflow: visible;
  }

  /* 排名看板内层 tab 的说明文字（仅未达标差异率 Top10 下方展示） */
  .page_dashboard .rank-tip {
    color: #8c8c8c;
    font-size: 12px;
    font-style: italic;
    line-height: 22px;
    padding: 2px 0 6px 4px;
  }

  .page_basicData .topOperation {
    background: #fff;
    padding: 0;
    display: flex;
    align-items: center;
  }

  .page_basicData .topOperation .top-left {
    flex: 1;
    display: flex;
    align-items: center;
  }

  .page_basicData .topOperation .top-left .fa {
    cursor: pointer;
    font-size: 13px;
    line-height: 1;
    height: 14px;
    color: #666;
  }

  .page_basicData .main-con {
    background: #fff;
    margin-top: 10px;
    padding: 0 16px 16px;
  }

  .page_basicData .crumbs {
    padding: 4px 0;
  }

  .placeholder-box {
    padding: 60px 20px;
    text-align: center;
    color: #909399;
    font-size: 14px;
    background: #fff;
  }

  .page_byProject {
    background: #f5f7fa;
  }

  .page_byProject .topOperation {
    background: #fff;
    padding: 15px 15px 0 15px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .page_byProject .topOperation .top-left {
    flex: 1;
  }

  .page_byProject .byProject-summary {
    background: #fff;
    padding: 10px 16px;
    border-bottom: 1px solid #ebeef5;
    font-size: 13px;
    color: #606266;
  }

  .page_byProject .byProject-summary .num {
    color: #409eff;
    font-weight: 600;
    padding: 0 4px;
  }

  .page_byProject .main-con {
    background: #fff;
  }

  .page_byServiceDept .topOperation {
    background: #fff;
    padding: 15px 15px 0 15px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .page_byServiceDept .topOperation .top-left {
    flex: 1;
  }

  .byCompany-summary {
    background: #fff;
    padding: 10px 16px;
    border-bottom: 1px solid #ebeef5;
    font-size: 13px;
    color: #606266;
  }

  .byCompany-summary .sum-row+.sum-row {
    margin-top: 4px;
  }

  .byCompany-summary .num {
    color: #409eff;
    font-weight: 600;
    padding: 0 4px;
  }

  .byCompany-summary .num-green {
    color: #52c41a;
  }

  .byCompany-summary .num-red {
    color: #ff4d4f;
  }

  .byCompany-summary .num-dark {
    color: #303133;
  }

  .byCompany-summary .num-purple {
    color: #6366f1;
  }

  .page_byServiceDept .byServiceDept-summary {
    background: #fff;
    padding: 10px 16px;
    border-bottom: 1px solid #ebeef5;
    font-size: 13px;
    color: #606266;
  }

  .page_byServiceDept .byServiceDept-summary .num {
    color: #409eff;
    font-weight: 600;
    padding: 0 4px;
  }

  .page_byServiceDept .main-con {
    background: #fff;
  }

  .page_socialSecurityList .topOperation {
    background: #fff;
    padding: 15px 15px 0 15px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .page_socialSecurityList .topOperation .top-left {
    flex: 1;
  }

  .page_socialSecurityList .topOperation .screenInput {
    display: inline-block;
    margin-left: 10px;
    line-height: 32px;
    cursor: pointer;
    color: #409eff;
    font-size: 13px;
  }

  .page_socialSecurityList .r_dropDownScreen {
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
    border-top: 1px solid #ebeef5;
  }

  .page_socialSecurityList .pro_down_box {
    padding: 5px 15px 0 15px;
  }

  .page_socialSecurityList .re_down_form .el-form-item {
    margin-bottom: 3px;
  }

  .page_socialSecurityList .drop-footer {
    text-align: right;
    padding: 0 15px 10px 15px;
  }

  .page_socialSecurityList .main-con {
    background: #fff;
    margin-top: 10px;
  }

  /* 报税数据 tab - 导入文件列（文件名 + 下载图标） */
  .tax_file_name {
    color: #606266;
    vertical-align: middle;
  }

  .tax_file_download {
    margin-left: 6px;
    color: #409eff;
    cursor: pointer;
    vertical-align: middle;
  }

  .tax_file_download:hover {
    color: #66b1ff;
  }
</style>

<style>
  .page_socialSecurityList .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_socialSecurityList .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }
</style>